// src/PendingsPanel.jsx
// LOOP PENDING PANEL WORKER PARITY V15 — same UI for owner/worker; worker actions use callable and scoped list.
// Redesigned PendingsPanel: modern, responsive, professional.
// Preserves Firestore realtime logic and approve/confirm actions from your previous implementation.
// LOOP PENDING PANEL V4 — approval-only queue + visual inbox cards.

import React, { useEffect, useState, useRef, useCallback } from "react";
import "./PendingsPolish.css";
import {
  collection,
  collectionGroup,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  serverTimestamp,
  getDoc,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { db as defaultDb } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import fsClient from "./data/firestoreClient";
import { isIosCapacitor } from "./utils/nativeHttp";
import { getManualAuth, isManualAuthLikelyValid } from "./utils/manualAuth";



function pendingMembershipBadge(booking = {}) {
  const applied = booking?.membershipApplied === true || booking?.membershipBenefitApplied === true || Boolean(booking?.customerMembershipId || booking?.membershipId);
  if (!applied) return null;
  const planName = String(booking.membershipPlanName || booking.membershipBenefitPlanName || "Membresía").trim() || "Membresía";
  const processed = booking.membershipBenefitProcessed === true || String(booking.membershipBenefitStatus || "").toLowerCase() === "processed" || String(booking.membershipBenefitStatus || "").toLowerCase() === "credit_used";
  const credits = Math.max(0, Number(booking.membershipCreditsUsed || 0) || 0);
  const text = processed ? `Crédito descontado · ${planName}` : credits > 0 ? `${credits} crédito pendiente · ${planName}` : `Membresía · ${planName}`;
  return { text, processed };
}

function PendingMembershipPill({ booking }) {
  const badge = pendingMembershipBadge(booking);
  if (!badge) return null;
  return (
    <div className={`pending-membership-pill ${badge.processed ? "is-processed" : ""}`} title={badge.text}>
      {badge.processed ? "Crédito descontado" : "Membresía"}
    </div>
  );
}

const PENDINGS_MOBILE_FIX_CSS = `
  @media (max-width: 768px) {
    table {
      border-collapse: separate !important;
      border-spacing: 0 12px !important;
    }

    thead {
      display: none !important;
    }

    tbody,
    tr,
    td {
      display: block !important;
      width: 100% !important;
    }

    tr {
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 24px !important;
      padding: 12px !important;
      margin-bottom: 12px !important;
      box-shadow: 0 12px 30px rgba(15,23,42,0.08) !important;
      overflow: hidden !important;
    }

    td {
      border: 0 !important;
      padding: 6px 4px !important;
      font-size: 13px !important;
    }

    td:last-child {
      display: flex !important;
      gap: 8px !important;
      justify-content: stretch !important;
      padding-top: 12px !important;
    }

    td:last-child button {
      flex: 1 1 0 !important;
      min-height: 42px !important;
      border-radius: 16px !important;
      font-size: 12px !important;
      font-weight: 950 !important;
    }

    .pendings-shell,
    .pendings-native-shell {
      padding: 10px 10px calc(118px + env(safe-area-inset-bottom, 0px)) !important;
      background: linear-gradient(180deg, #f8fafc 0%, #ffffff 55%, #f8fafc 100%) !important;
    }

    .pendings-desktop-table,
    table.pendings-table,
    .pendings-table {
      display: none !important;
    }

    .pendings-mobile-list {
      display: grid !important;
      gap: 12px !important;
    }

    .pending-mobile-card {
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 24px !important;
      padding: 14px !important;
      box-shadow: 0 12px 30px rgba(15,23,42,0.08) !important;
    }

    .pending-mobile-top {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      margin-bottom: 12px !important;
    }

    .pending-mobile-avatar {
      width: 46px !important;
      height: 46px !important;
      border-radius: 16px !important;
      background: #ecfdf5 !important;
      color: #047857 !important;
      display: grid !important;
      place-items: center !important;
      font-weight: 950 !important;
      flex: 0 0 auto !important;
    }

    .pending-mobile-name {
      font-size: 16px !important;
      font-weight: 950 !important;
      color: #0f172a !important;
      line-height: 1.1 !important;
    }

    .pending-mobile-meta {
      font-size: 12px !important;
      font-weight: 750 !important;
      color: #64748b !important;
      margin-top: 3px !important;
    }

    .pending-mobile-grid {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 8px !important;
      margin: 12px 0 !important;
    }

    .pending-mobile-chip {
      border-radius: 16px !important;
      background: #f8fafc !important;
      border: 1px solid #e2e8f0 !important;
      padding: 10px !important;
      min-width: 0 !important;
    }

    .pending-mobile-chip span {
      display: block !important;
      font-size: 10px !important;
      font-weight: 950 !important;
      text-transform: uppercase !important;
      letter-spacing: .08em !important;
      color: #94a3b8 !important;
      margin-bottom: 3px !important;
    }

    .pending-mobile-chip strong {
      display: block !important;
      font-size: 12px !important;
      font-weight: 950 !important;
      color: #0f172a !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
    }

    .pending-mobile-actions {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 8px !important;
      margin-top: 12px !important;
    }

    .pending-mobile-actions button {
      min-height: 44px !important;
      border-radius: 16px !important;
      font-size: 13px !important;
      font-weight: 950 !important;
    }
  }

  @media (min-width: 769px) {
    .pendings-mobile-list {
      display: none !important;
    }
  }

  /* =========================================================
     PHASE A.2 — PREMIUM COMPACT PENDING CARDS
     Desktop also behaves like clean operational cards.
     ========================================================= */

  .pending-membership-pill{display:inline-flex;align-items:center;width:max-content;max-width:100%;margin-top:7px;border:1px solid #99f6e4;background:#f0fdfa;color:#0f766e;border-radius:999px;padding:5px 8px;font-size:10px;font-weight:950;letter-spacing:.02em}.pending-membership-pill.is-processed{background:#ecfdf5;border-color:#86efac;color:#047857}

  .pendings-premium-board {
    display: grid !important;
    gap: 12px !important;
  }

  .pendings-premium-card {
    display: grid !important;
    grid-template-columns: minmax(170px, 1.15fr) minmax(120px, .75fr) minmax(260px, 1.9fr) minmax(88px, .55fr) minmax(116px, .65fr) minmax(190px, .95fr) !important;
    gap: 16px !important;
    align-items: center !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 26px !important;
    background: #ffffff !important;
    padding: 16px !important;
    box-shadow: 0 12px 30px rgba(15,23,42,.055) !important;
    transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease !important;
  }

  .pendings-premium-card:hover {
    transform: translateY(-1px) !important;
    border-color: #d9e4ef !important;
    box-shadow: 0 18px 42px rgba(15,23,42,.08) !important;
  }

  .pending-card-label {
    display: block !important;
    margin-bottom: 5px !important;
    font-size: 10px !important;
    line-height: 1 !important;
    font-weight: 950 !important;
    text-transform: uppercase !important;
    letter-spacing: .10em !important;
    color: #94a3b8 !important;
  }

  .pending-card-main {
    font-size: 14px !important;
    font-weight: 950 !important;
    color: #0f172a !important;
    line-height: 1.2 !important;
  }

  .pending-card-sub {
    margin-top: 4px !important;
    font-size: 12px !important;
    font-weight: 800 !important;
    color: #64748b !important;
    line-height: 1.25 !important;
  }

  .pending-card-location {
    margin-top: 7px !important;
    display: inline-flex !important;
    max-width: 100% !important;
    align-items: center !important;
    gap: 6px !important;
    border-radius: 999px !important;
    background: #ecfdf5 !important;
    color: #047857 !important;
    padding: 6px 9px !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    line-height: 1.15 !important;
  }

  .pending-card-location.is-local {
    background: #f1f5f9 !important;
    color: #475569 !important;
  }

  .pending-card-total {
    font-size: 18px !important;
    font-weight: 950 !important;
    color: #0f172a !important;
    letter-spacing: -.03em !important;
  }

  .pending-card-actions {
    display: flex !important;
    gap: 8px !important;
    justify-content: flex-end !important;
    flex-wrap: nowrap !important;
  }

  .pending-card-actions button {
    white-space: nowrap !important;
  }

  .pending-detail-modal-shell {
    max-height: min(86vh, 760px) !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .pending-detail-modal-body {
    overflow-y: auto !important;
    padding-bottom: 4px !important;
  }

  @media (max-width: 1180px) {
    .pendings-premium-card {
      grid-template-columns: minmax(170px, 1fr) minmax(250px, 1.7fr) minmax(80px, .45fr) minmax(105px, .55fr) !important;
    }

    .pending-card-worker-col {
      display: none !important;
    }
  }

  @media (max-width: 900px) {
    .pendings-premium-card {
      grid-template-columns: 1fr !important;
      gap: 12px !important;
    }

    .pending-card-actions {
      justify-content: stretch !important;
    }

    .pending-card-actions button {
      flex: 1 1 0 !important;
      min-height: 42px !important;
    }
  }


  /* =========================================================
     LOOP PENDINGS REVAMP — compact operational approval queue
     Visual-only layer. Keeps Firestore, approval and assignment logic intact.
     ========================================================= */

  .pendings-revamp-shell {
    color: #0f172a;
  }

  .pendings-revamp-header {
    background:
      radial-gradient(circle at 0% 0%, rgba(0, 103, 95, 0.095), transparent 32%),
      linear-gradient(135deg, rgba(255,255,255,0.98), rgba(248,250,252,0.96));
  }

  .pendings-revamp-header h1 {
    letter-spacing: -0.075em;
  }

  .pendings-metric-chip {
    min-height: 62px;
    border: 1px solid rgba(226,232,240,.92);
    background: rgba(255,255,255,.88);
    border-radius: 22px;
    padding: 12px 14px;
    box-shadow: 0 10px 26px rgba(15,23,42,.045);
  }

  .pendings-metric-chip span {
    display: block;
    color: #64748b;
    font-size: 10px;
    line-height: 1;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: .12em;
  }

  .pendings-metric-chip strong {
    display: block;
    margin-top: 7px;
    color: #0f172a;
    font-size: 22px;
    line-height: 1;
    letter-spacing: -.05em;
    font-weight: 950;
  }

  .pendings-mode-alert {
    min-height: 46px;
  }

  .pendings-filter-bar {
    position: sticky;
    top: 74px;
    z-index: 12;
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
  }

  .pendings-segmented {
    background: rgba(255,255,255,.82);
    border: 1px solid rgba(226,232,240,.92);
    border-radius: 999px;
    padding: 5px;
    box-shadow: 0 10px 26px rgba(15,23,42,.045);
  }

  .pendings-segmented button {
    min-height: 38px;
    border-radius: 999px;
    padding: 0 15px;
    font-size: 12px;
    font-weight: 950;
    transition: transform .15s ease, background .15s ease, color .15s ease, box-shadow .15s ease;
  }

  .pendings-segmented button:active {
    transform: scale(.985);
  }

  .pendings-date-group {
    display: grid;
    gap: 10px;
  }

  .pendings-date-group + .pendings-date-group {
    margin-top: 18px;
  }

  .pendings-date-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 0 4px;
  }

  .pendings-date-title span {
    color: #0f172a;
    font-size: 14px;
    font-weight: 950;
    letter-spacing: -.025em;
  }

  .pendings-date-title em {
    color: #64748b;
    font-size: 11px;
    font-style: normal;
    font-weight: 950;
  }

  .pendings-compact-list {
    display: grid;
    gap: 10px;
  }

  .pending-revamp-card {
    display: grid;
    grid-template-columns: minmax(220px, 1.05fr) minmax(280px, 1.35fr) minmax(92px, .36fr) minmax(260px, auto);
    gap: 14px;
    align-items: center;
    border: 1px solid rgba(226,232,240,.92);
    border-radius: 26px;
    background: rgba(255,255,255,.96);
    padding: 14px 16px;
    box-shadow: 0 12px 30px rgba(15,23,42,.052);
    transition: transform .15s ease, border-color .15s ease, box-shadow .15s ease;
  }

  .pending-revamp-card:hover {
    transform: translateY(-1px);
    border-color: rgba(0,103,95,.20);
    box-shadow: 0 18px 42px rgba(15,23,42,.075);
  }

  .pending-revamp-card.is-unassigned {
    border-color: rgba(245,158,11,.32);
    background:
      radial-gradient(circle at 0% 0%, rgba(245,158,11,.06), transparent 24%),
      rgba(255,255,255,.97);
  }

  .pending-revamp-client {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .pending-revamp-avatar {
    width: 46px;
    height: 46px;
    border-radius: 18px;
    background: #ecfdf5;
    color: #047857;
    display: grid;
    place-items: center;
    font-weight: 950;
    flex: 0 0 auto;
  }

  .pending-revamp-kicker {
    display: block;
    color: #94a3b8;
    font-size: 10px;
    line-height: 1;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: .11em;
    margin-bottom: 5px;
  }

  .pending-revamp-main {
    min-width: 0;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.12;
    font-weight: 950;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pending-revamp-sub {
    margin-top: 5px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.24;
    font-weight: 800;
  }

  .pending-revamp-service {
    min-width: 0;
  }

  .pending-revamp-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-top: 8px;
  }

  .pending-revamp-pill {
    min-height: 25px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border-radius: 999px;
    border: 1px solid rgba(226,232,240,.92);
    background: #f8fafc;
    color: #475569;
    padding: 0 9px;
    font-size: 11px;
    line-height: 1;
    font-weight: 950;
  }

  .pending-revamp-pill.is-delivery {
    border-color: rgba(153,246,228,.95);
    background: #f0fdfa;
    color: #0f766e;
  }

  .pending-revamp-pill.is-unassigned {
    border-color: rgba(253,230,138,.95);
    background: #fffbeb;
    color: #b45309;
  }

  .pending-revamp-total {
    text-align: left;
  }

  .pending-revamp-total strong {
    display: block;
    color: #0f172a;
    font-size: 20px;
    line-height: 1;
    letter-spacing: -.045em;
    font-weight: 950;
  }

  .pending-revamp-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }

  .pending-revamp-actions button {
    min-height: 38px;
    border-radius: 16px;
    padding: 0 13px;
    font-size: 12px;
    font-weight: 950;
    white-space: nowrap;
    transition: transform .15s ease, filter .15s ease, box-shadow .15s ease;
  }

  .pending-revamp-actions button:active {
    transform: scale(.985);
  }

  .pending-revamp-detail-btn {
    border: 1px solid rgba(226,232,240,.95);
    background: #ffffff;
    color: #334155;
  }

  .pending-revamp-accept-btn {
    border: 0;
    background: #009b72;
    color: #ffffff;
    box-shadow: 0 12px 22px rgba(0,155,114,.18);
  }

  .pending-revamp-reject-btn {
    border: 0;
    background: #dc2626;
    color: #ffffff;
    box-shadow: 0 10px 18px rgba(220,38,38,.14);
  }

  .pending-revamp-empty {
    border: 1px dashed rgba(148,163,184,.55);
    background: rgba(255,255,255,.86);
    border-radius: 28px;
    padding: 44px 20px;
    text-align: center;
    color: #64748b;
    font-weight: 800;
  }

  .pending-revamp-loading-card {
    height: 88px;
    border-radius: 26px;
    background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 50%, #f1f5f9 100%);
    background-size: 200% 100%;
    animation: loopPendingRevampShimmer 1.25s infinite linear;
  }

  @keyframes loopPendingRevampShimmer {
    from { background-position: 200% 0; }
    to { background-position: -200% 0; }
  }

  @media (max-width: 1180px) {
    .pending-revamp-card {
      grid-template-columns: minmax(210px, 1fr) minmax(260px, 1.2fr) minmax(84px, .35fr);
    }

    .pending-revamp-actions {
      grid-column: 1 / -1;
      justify-content: flex-end;
      border-top: 1px solid rgba(241,245,249,.95);
      padding-top: 12px;
    }
  }

  @media (max-width: 768px) {
    .pendings-filter-bar {
      position: relative;
      top: auto;
    }

    .pendings-metric-chip {
      min-height: 58px;
      padding: 11px 12px;
      border-radius: 19px;
    }

    .pending-revamp-card {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 14px;
      border-radius: 24px;
    }

    .pending-revamp-total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid rgba(241,245,249,.95);
      padding-top: 10px;
    }

    .pending-revamp-total .pending-revamp-kicker {
      margin: 0;
    }

    .pending-revamp-actions {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 8px;
      padding-top: 0;
      border-top: 0;
    }

    .pending-revamp-actions button {
      min-height: 42px;
      padding: 0 10px;
    }
  }

  @media (max-width: 520px) {
    .pending-revamp-actions {
      grid-template-columns: 1fr;
    }
  }


  /* =========================================================
     LOOP PENDING PANEL APPROVAL ONLY V1 — notification focus
     ========================================================= */
  .pending-revamp-card.is-focused-from-notification {
    border-color: rgba(0, 103, 95, .42) !important;
    box-shadow: 0 18px 42px rgba(0, 103, 95, .16) !important;
    background:
      radial-gradient(circle at 0% 0%, rgba(0,103,95,.08), transparent 30%),
      rgba(255,255,255,.98) !important;
  }

  .pending-notification-bridge {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border: 1px solid rgba(0,103,95,.14);
    background: #f0fdfa;
    color: #0f766e;
    border-radius: 22px;
    padding: 11px 14px;
    font-size: 12px;
    font-weight: 900;
    box-shadow: 0 10px 24px rgba(15,23,42,.04);
  }

  .pending-notification-bridge strong {
    color: #00675f;
    font-weight: 950;
  }

  .pending-notification-bridge.is-missing {
    border-color: rgba(245,158,11,.28);
    background: #fffbeb;
    color: #92400e;
  }

  .pending-notification-bridge.is-missing strong { color: #b45309; }


  /* =========================================================
     LOOP PENDING PANEL V2 — compact header + manual/auto control
     ========================================================= */

  .pendings-approval-hero {
    padding-top: 22px !important;
    padding-bottom: 22px !important;
  }

  .pendings-approval-mode-card {
    min-height: 112px;
    border: 1px solid rgba(226,232,240,.96);
    border-radius: 26px;
    background:
      radial-gradient(circle at 0% 0%, rgba(0,103,95,.10), transparent 34%),
      rgba(255,255,255,.94);
    box-shadow: 0 12px 30px rgba(15,23,42,.055);
    padding: 13px;
    display: grid;
    gap: 11px;
    align-content: center;
  }

  .pendings-approval-mode-card.is-manual {
    border-color: rgba(245,158,11,.28);
    background:
      radial-gradient(circle at 0% 0%, rgba(245,158,11,.10), transparent 34%),
      rgba(255,255,255,.96);
  }

  .pendings-approval-mode-card.is-auto {
    border-color: rgba(20,184,166,.26);
  }

  .pendings-approval-mode-copy {
    min-width: 0;
  }

  .pendings-approval-mode-copy span {
    display: block;
    color: #64748b;
    font-size: 10px;
    line-height: 1;
    font-weight: 950;
    letter-spacing: .12em;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .pendings-approval-mode-copy strong {
    display: block;
    color: #0f172a;
    font-size: 19px;
    line-height: 1;
    letter-spacing: -.045em;
    font-weight: 950;
  }

  .pendings-approval-mode-copy small {
    display: block;
    margin-top: 6px;
    color: #64748b;
    font-size: 11.5px;
    line-height: 1.25;
    font-weight: 820;
  }

  .pendings-approval-mode-switch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5px;
    border: 1px solid rgba(226,232,240,.96);
    background: #f8fafc;
    border-radius: 999px;
    padding: 4px;
  }

  .pendings-approval-mode-switch button {
    min-height: 32px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #475569;
    font-size: 11px;
    font-weight: 950;
    cursor: pointer;
    transition: transform .14s ease, background .14s ease, color .14s ease, box-shadow .14s ease;
  }

  .pendings-approval-mode-switch button:active {
    transform: scale(.985);
  }

  .pendings-approval-mode-switch button.is-active {
    background: #00675f;
    color: #ffffff;
    box-shadow: 0 9px 18px rgba(0,103,95,.16);
  }

  .pendings-approval-mode-switch button:disabled {
    cursor: progress;
    opacity: .72;
  }

  .pendings-approval-mode-card em {
    color: #64748b;
    font-size: 10.5px;
    font-style: normal;
    font-weight: 900;
  }

  .pendings-filter-bar {
    top: 68px !important;
  }

  @media (max-width: 1280px) {
    .pendings-approval-mode-card {
      max-width: 420px;
    }
  }

  @media (max-width: 768px) {
    .pendings-approval-hero {
      padding: 16px !important;
      border-radius: 28px !important;
    }

    .pendings-approval-mode-card {
      max-width: none;
      min-height: 0;
    }
  }


/* =========================================================
   LOOP PENDING PANEL V3 — compact mode status + modal editor
   ========================================================= */
  .pendings-approval-hero {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .pendings-approval-mode-card.is-summary {
    min-height: 74px !important;
    max-width: 360px !important;
    border-radius: 24px !important;
    padding: 13px 14px !important;
    grid-template-columns: 42px minmax(0, 1fr) auto !important;
    display: grid !important;
    align-items: center !important;
    align-content: center !important;
    gap: 11px !important;
    box-shadow: 0 10px 24px rgba(15,23,42,.052) !important;
  }

  .pendings-approval-mode-card.is-summary.is-manual {
    border-color: rgba(245,158,11,.22) !important;
    background: linear-gradient(135deg, rgba(255,251,235,.96), rgba(255,255,255,.98)) !important;
  }

  .pendings-approval-mode-card.is-summary.is-auto {
    border-color: rgba(20,184,166,.24) !important;
    background: linear-gradient(135deg, rgba(240,253,250,.96), rgba(255,255,255,.98)) !important;
  }

  .pendings-approval-status-icon {
    width: 42px !important;
    height: 42px !important;
    border-radius: 16px !important;
    display: grid !important;
    place-items: center !important;
    font-size: 17px !important;
    font-weight: 950 !important;
    background: #ecfdf5 !important;
    color: #00675f !important;
  }

  .pendings-approval-mode-card.is-summary.is-manual .pendings-approval-status-icon {
    background: #fffbeb !important;
    color: #b45309 !important;
  }

  .pendings-approval-mode-card.is-summary .pendings-approval-mode-copy span {
    margin-bottom: 4px !important;
    font-size: 9.5px !important;
  }

  .pendings-approval-mode-card.is-summary .pendings-approval-mode-copy strong {
    font-size: 16px !important;
    letter-spacing: -.035em !important;
  }

  .pendings-approval-mode-card.is-summary .pendings-approval-mode-copy small {
    margin-top: 4px !important;
    font-size: 11px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .pendings-approval-edit-btn {
    min-height: 34px !important;
    border: 1px solid rgba(0,103,95,.16) !important;
    background: #ffffff !important;
    color: #00675f !important;
    border-radius: 999px !important;
    padding: 0 12px !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    cursor: pointer !important;
    box-shadow: 0 8px 18px rgba(15,23,42,.045) !important;
    white-space: nowrap !important;
  }

  .pendings-approval-edit-btn:hover {
    background: #f0fdfa !important;
    border-color: rgba(0,103,95,.24) !important;
  }

  .pendings-approval-edit-btn:disabled {
    opacity: .62 !important;
    cursor: progress !important;
  }

  .pending-approval-modal-shell {
    position: fixed;
    inset: 0;
    z-index: 10020;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
  }

  .pending-approval-modal-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, .48);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .pending-approval-modal-card {
    position: relative;
    width: min(520px, calc(100vw - 28px));
    max-height: min(86vh, 680px);
    overflow: hidden;
    border-radius: 30px;
    border: 1px solid rgba(226,232,240,.95);
    background: #ffffff;
    box-shadow: 0 34px 90px rgba(15,23,42,.28);
    display: flex;
    flex-direction: column;
  }

  .pending-approval-modal-head {
    padding: 22px 22px 18px;
    background:
      radial-gradient(circle at 0% 0%, rgba(0,103,95,.13), transparent 35%),
      linear-gradient(135deg, #ffffff, #fbfffd);
    border-bottom: 1px solid rgba(226,232,240,.75);
  }

  .pending-approval-modal-head span {
    display: block;
    color: #00675f;
    font-size: 10px;
    line-height: 1;
    font-weight: 950;
    letter-spacing: .14em;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  .pending-approval-modal-head h3 {
    margin: 0;
    color: #0f172a;
    font-size: 26px;
    line-height: 1;
    letter-spacing: -.065em;
    font-weight: 950;
  }

  .pending-approval-modal-head p {
    margin: 9px 0 0;
    color: #64748b;
    font-size: 13px;
    line-height: 1.45;
    font-weight: 760;
  }

  .pending-approval-modal-body {
    padding: 16px;
    overflow-y: auto;
    display: grid;
    gap: 11px;
  }

  .pending-approval-choice {
    width: 100%;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    border-radius: 22px;
    padding: 14px;
    display: grid;
    grid-template-columns: 42px minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
    text-align: left;
    cursor: pointer;
    transition: transform .14s ease, border-color .14s ease, background .14s ease, box-shadow .14s ease;
  }

  .pending-approval-choice:hover {
    transform: translateY(-1px);
    border-color: rgba(0,103,95,.20);
    box-shadow: 0 12px 28px rgba(15,23,42,.06);
  }

  .pending-approval-choice.is-active {
    border-color: rgba(20,184,166,.34);
    background: #f0fdfa;
    box-shadow: 0 12px 28px rgba(0,103,95,.075);
  }

  .pending-approval-choice-icon {
    width: 42px;
    height: 42px;
    border-radius: 16px;
    display: grid;
    place-items: center;
    background: #f8fafc;
    color: #475569;
    font-weight: 950;
    font-size: 17px;
  }

  .pending-approval-choice.is-active .pending-approval-choice-icon {
    background: #00675f;
    color: #ffffff;
  }

  .pending-approval-choice strong {
    display: block;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.1;
    font-weight: 950;
  }

  .pending-approval-choice small {
    display: block;
    margin-top: 5px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.35;
    font-weight: 760;
  }

  .pending-approval-choice-check {
    width: 24px;
    height: 24px;
    border-radius: 999px;
    border: 1px solid #cbd5e1;
    display: grid;
    place-items: center;
    color: transparent;
    font-size: 12px;
    font-weight: 950;
  }

  .pending-approval-choice.is-active .pending-approval-choice-check {
    background: #00675f;
    border-color: #00675f;
    color: #ffffff;
  }

  .pending-approval-modal-note {
    border: 1px solid rgba(226,232,240,.92);
    background: #f8fafc;
    border-radius: 18px;
    padding: 12px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.4;
    font-weight: 760;
  }

  .pending-approval-modal-note strong {
    color: #00675f;
    font-weight: 950;
  }

  .pending-approval-modal-error {
    border: 1px solid rgba(248,113,113,.40);
    background: #fef2f2;
    color: #b91c1c;
    border-radius: 16px;
    padding: 11px 12px;
    font-size: 12px;
    line-height: 1.35;
    font-weight: 850;
  }

  .pending-approval-modal-footer {
    border-top: 1px solid rgba(226,232,240,.75);
    padding: 14px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    background: #ffffff;
  }

  .pending-approval-modal-footer button {
    min-height: 42px;
    border-radius: 16px;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 950;
    cursor: pointer;
  }

  .pending-approval-modal-cancel {
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;
  }

  .pending-approval-modal-save {
    border: 0;
    background: #00796f;
    color: #ffffff;
    box-shadow: 0 12px 24px rgba(0,103,95,.16);
  }

  .pending-approval-modal-save:disabled,
  .pending-approval-modal-cancel:disabled {
    opacity: .62;
    cursor: progress;
  }

  @media (max-width: 768px) {
    .pendings-approval-mode-card.is-summary {
      max-width: none !important;
      grid-template-columns: 40px minmax(0, 1fr) auto !important;
    }

    .pending-approval-modal-card {
      border-radius: 26px;
    }

    .pending-approval-modal-footer {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }


/* =========================================================
   LOOP PENDING PANEL V4 — visual inbox cards
   Calm approval inbox. Logic stays untouched.
   ========================================================= */
  .pendings-revamp-shell .pendings-approval-hero {
    margin-bottom: 12px !important;
  }

  .pendings-revamp-shell .pendings-filter-bar {
    margin-bottom: 14px !important;
    box-shadow: 0 10px 26px rgba(15,23,42,.045) !important;
  }

  .pendings-revamp-shell .pendings-date-group {
    gap: 8px !important;
  }

  .pendings-revamp-shell .pendings-date-group + .pendings-date-group {
    margin-top: 14px !important;
  }

  .pendings-revamp-shell .pendings-date-title {
    padding: 0 4px 2px !important;
  }

  .pendings-revamp-shell .pendings-date-title span {
    font-size: 13px !important;
    letter-spacing: -.018em !important;
  }

  .pendings-revamp-shell .pendings-date-title em {
    font-size: 10.5px !important;
    color: #94a3b8 !important;
  }

  .pendings-revamp-shell .pendings-compact-list {
    gap: 8px !important;
  }

  .pending-inbox-card.pending-revamp-card {
    position: relative !important;
    grid-template-columns: minmax(0, 1fr) minmax(82px, auto) auto !important;
    gap: 14px !important;
    align-items: center !important;
    min-height: 86px !important;
    padding: 11px 13px !important;
    border-radius: 22px !important;
    border-color: rgba(226,232,240,.92) !important;
    background: rgba(255,255,255,.98) !important;
    box-shadow: 0 8px 22px rgba(15,23,42,.045) !important;
  }

  .pending-inbox-card.pending-revamp-card::before {
    content: "";
    position: absolute;
    left: 0;
    top: 16px;
    bottom: 16px;
    width: 3px;
    border-radius: 0 999px 999px 0;
    background: transparent;
  }

  .pending-inbox-card.pending-revamp-card:hover {
    transform: translateY(-1px) !important;
    border-color: rgba(0,103,95,.16) !important;
    box-shadow: 0 14px 34px rgba(15,23,42,.07) !important;
  }

  .pending-inbox-card.pending-revamp-card.is-unassigned {
    border-color: rgba(245,158,11,.26) !important;
    background:
      radial-gradient(circle at 0% 0%, rgba(245,158,11,.055), transparent 25%),
      rgba(255,255,255,.985) !important;
  }

  .pending-inbox-card.pending-revamp-card.is-unassigned::before {
    background: #f59e0b;
  }

  .pending-inbox-card.pending-revamp-card.is-overdue:not(.is-unassigned)::before {
    background: #94a3b8;
  }

  .pending-inbox-leading {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .pending-inbox-avatar {
    width: 42px;
    height: 42px;
    border-radius: 16px;
    background: #ecfdf5;
    color: #047857;
    display: grid;
    place-items: center;
    font-size: 14px;
    font-weight: 950;
    flex: 0 0 auto;
  }

  .pending-inbox-card.is-unassigned .pending-inbox-avatar {
    background: #fffbeb;
    color: #b45309;
  }

  .pending-inbox-copy {
    min-width: 0;
  }

  .pending-inbox-kicker {
    display: block;
    margin-bottom: 3px;
    color: #94a3b8;
    font-size: 9.5px;
    line-height: 1;
    font-weight: 950;
    letter-spacing: .10em;
    text-transform: uppercase;
  }

  .pending-inbox-copy strong {
    display: block;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.08;
    font-weight: 950;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pending-inbox-copy p {
    margin: 4px 0 0;
    color: #64748b;
    font-size: 12px;
    line-height: 1.25;
    font-weight: 820;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pending-inbox-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 7px;
  }

  .pending-inbox-pill,
  .pending-inbox-meta .pending-membership-pill {
    min-height: 23px !important;
    display: inline-flex !important;
    align-items: center !important;
    width: max-content !important;
    max-width: 100% !important;
    margin: 0 !important;
    border-radius: 999px !important;
    border: 1px solid rgba(226,232,240,.95) !important;
    background: #f8fafc !important;
    color: #475569 !important;
    padding: 0 8px !important;
    font-size: 10.5px !important;
    line-height: 1 !important;
    font-weight: 950 !important;
    letter-spacing: 0 !important;
  }

  .pending-inbox-pill.is-delivery {
    border-color: rgba(153,246,228,.95) !important;
    background: #f0fdfa !important;
    color: #0f766e !important;
  }

  .pending-inbox-pill.is-unassigned {
    border-color: rgba(253,230,138,.95) !important;
    background: #fffbeb !important;
    color: #b45309 !important;
  }

  .pending-inbox-meta .pending-membership-pill {
    border-color: #99f6e4 !important;
    background: #f0fdfa !important;
    color: #0f766e !important;
  }

  .pending-inbox-total {
    min-width: 72px;
    text-align: right;
  }

  .pending-inbox-total span {
    display: block;
    color: #94a3b8;
    font-size: 9.5px;
    line-height: 1;
    font-weight: 950;
    letter-spacing: .10em;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .pending-inbox-total strong {
    color: #0f172a;
    font-size: 16px;
    line-height: 1;
    font-weight: 950;
    letter-spacing: -.035em;
  }

  .pending-inbox-actions.pending-revamp-actions {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    gap: 7px !important;
    padding: 0 !important;
    border: 0 !important;
  }

  .pending-inbox-actions button {
    min-height: 34px !important;
    border-radius: 999px !important;
    padding: 0 12px !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    box-shadow: none !important;
  }

  .pending-inbox-detail-btn {
    border: 1px solid rgba(226,232,240,.95) !important;
    background: #ffffff !important;
    color: #334155 !important;
  }

  .pending-inbox-reject-btn {
    border: 1px solid rgba(248,113,113,.38) !important;
    background: #fff7f7 !important;
    color: #dc2626 !important;
  }

  .pending-inbox-accept-btn {
    border: 0 !important;
    background: #009b72 !important;
    color: #ffffff !important;
    box-shadow: 0 9px 18px rgba(0,155,114,.14) !important;
  }

  .pending-inbox-card.is-unassigned .pending-inbox-accept-btn {
    background: #0f766e !important;
  }

  @media (max-width: 1180px) {
    .pending-inbox-card.pending-revamp-card {
      grid-template-columns: minmax(0, 1fr) auto !important;
    }

    .pending-inbox-total {
      text-align: right;
    }

    .pending-inbox-actions.pending-revamp-actions {
      grid-column: 1 / -1;
      justify-content: flex-end !important;
      border-top: 1px solid rgba(241,245,249,.95) !important;
      padding-top: 10px !important;
    }
  }

  @media (max-width: 768px) {
    .pending-inbox-card.pending-revamp-card {
      grid-template-columns: 1fr !important;
      min-height: 0 !important;
      padding: 13px !important;
      gap: 11px !important;
    }

    .pending-inbox-leading {
      align-items: flex-start;
    }

    .pending-inbox-copy p {
      white-space: normal;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .pending-inbox-total {
      min-width: 0;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid rgba(241,245,249,.95);
      padding-top: 10px;
    }

    .pending-inbox-total span {
      margin: 0;
    }

    .pending-inbox-actions.pending-revamp-actions {
      display: grid !important;
      grid-template-columns: 1fr 1fr 1fr !important;
      gap: 8px !important;
      padding-top: 0 !important;
      border-top: 0 !important;
    }

    .pending-inbox-actions button {
      min-height: 40px !important;
      padding: 0 9px !important;
    }
  }

  @media (max-width: 520px) {
    .pending-inbox-actions.pending-revamp-actions {
      grid-template-columns: 1fr !important;
    }
  }

`;

/* ----------------------
   Small UI subcomponents
   ---------------------- */

function IconUser({ name, size = 40 }) {
  const initial = name ? (name.trim()[0] || "?").toUpperCase() : "?";
  return (
    <div
      aria-hidden
      className="flex items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700 font-black shadow-sm"
      style={{ width: size, height: size }}
    >
      {initial}
    </div>
  );
}


function ConfirmModal({ open, title, description, confirmText = "Confirmar", onClose, onConfirm, destructive = false }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-slate-950/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-2xl">
        <div
          className="px-6 py-5"
          style={{
            background: destructive
              ? "linear-gradient(135deg, rgba(239,68,68,0.10) 0%, rgba(255,255,255,1) 62%)"
              : "linear-gradient(135deg, rgba(15,118,110,0.10) 0%, rgba(255,255,255,1) 62%)",
          }}
        >
          <div className={`mb-3 inline-flex h-12 w-12 items-center justify-center rounded-2xl text-xl ${destructive ? "bg-red-50 text-red-600" : "bg-emerald-50 text-emerald-700"}`}>
            {destructive ? "!" : "✓"}
          </div>
          <h3 className="text-xl font-black tracking-tight text-slate-950">{title}</h3>
          <p className="mt-2 text-sm font-semibold leading-6 text-slate-500">{description}</p>
        </div>
        <div className="flex gap-3 border-t border-slate-100 p-4">
          <button type="button" onClick={onClose} className="flex-1 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700 transition hover:bg-slate-50 active:scale-[0.98]">
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm && onConfirm();
            }}
            className={`flex-1 rounded-2xl px-4 py-3 text-sm font-black text-white shadow-sm transition active:scale-[0.98] ${destructive ? "bg-red-600 hover:bg-red-700" : "bg-emerald-600 hover:bg-emerald-700"}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

function ApprovalModeSettingsModal({ open, value, saving, status, onChange, onClose, onSave }) {
  if (!open) return null;
  const isAuto = value === "auto";
  return (
    <div className="pending-approval-modal-shell">
      <div className="pending-approval-modal-backdrop" onClick={saving ? undefined : onClose} />
      <div className="pending-approval-modal-card" role="dialog" aria-modal="true" aria-label="Editar modo de aprobación">
        <div className="pending-approval-modal-head">
          <span>Aprobación de reservas</span>
          <h3>¿Cómo quieres confirmar reservas?</h3>
          <p>Este ajuste se sincroniza con Agenda y aplica a las reservas online nuevas. Las solicitudes pendientes actuales no cambian solas.</p>
        </div>

        <div className="pending-approval-modal-body">
          <button
            type="button"
            className={`pending-approval-choice ${!isAuto ? "is-active" : ""}`}
            onClick={() => onChange("manual")}
            disabled={saving}
          >
            <span className="pending-approval-choice-icon">✓</span>
            <span>
              <strong>Manual</strong>
              <small>Las reservas online llegan al Pending Panel para que el negocio las acepte o rechace.</small>
            </span>
            <span className="pending-approval-choice-check">✓</span>
          </button>

          <button
            type="button"
            className={`pending-approval-choice ${isAuto ? "is-active" : ""}`}
            onClick={() => onChange("auto")}
            disabled={saving}
          >
            <span className="pending-approval-choice-icon">⚡</span>
            <span>
              <strong>Automático</strong>
              <small>Las reservas online entran directo a la agenda si el horario está disponible.</small>
            </span>
            <span className="pending-approval-choice-check">✓</span>
          </button>

          <div className="pending-approval-modal-note">
            <strong>Nota:</strong> este cambio no aprueba ni cancela las reservas que ya están pendientes. Solo cambia el comportamiento de nuevas solicitudes.
          </div>

          {status ? <div className="pending-approval-modal-error">{status}</div> : null}
        </div>

        <div className="pending-approval-modal-footer">
          <button type="button" className="pending-approval-modal-cancel" onClick={onClose} disabled={saving}>Cancelar</button>
          <button type="button" className="pending-approval-modal-save" onClick={() => onSave(value)} disabled={saving}>{saving ? "Guardando..." : "Guardar cambios"}</button>
        </div>
      </div>
    </div>
  );
}

/* ----------------------
   Utility formatters
   ---------------------- */
function fmtDateTime(b) {
  try {
    if (!b) return "-";
    if (b.date && b.time) return `${b.date} ${b.time}`;
    if (b.scheduledAt && b.scheduledAt.toDate) {
      const d = b.scheduledAt.toDate();
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    }
    if (b.scheduledAt) {
      const d = new Date(b.scheduledAt);
      if (!Number.isNaN(d.getTime())) return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    }
    return b.date || "-";
  } catch {
    return "-";
  }
}


function timestampToMillis(v) {
  try {
    if (!v) return null;
    if (typeof v.toDate === "function") return v.toDate().getTime();
    if (v.seconds) return Number(v.seconds) * 1000;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d.getTime();
  } catch (_) {
    return null;
  }
}


function normalizeServiceKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function getEmployeeServiceKeys(emp) {
  const raw = Array.isArray(emp?.services) ? emp.services : [];
  const keys = [];
  raw.forEach((item) => {
    if (item == null) return;
    if (typeof item === "string" || typeof item === "number") {
      keys.push(normalizeServiceKey(item));
    } else if (typeof item === "object") {
      [item.id, item.serviceId, item.name, item.title, item.path].forEach((v) => {
        const k = normalizeServiceKey(v);
        if (k) keys.push(k);
      });
    }
  });
  return Array.from(new Set(keys.filter(Boolean)));
}

function employeeCanDoService(emp, booking, services = []) {
  if (!emp) return false;

  const assigned = getEmployeeServiceKeys(emp);
  // Backwards compatible: if the worker has no configured services, allow.
  if (assigned.length === 0) return true;

  const svcId = booking?.serviceId || booking?.serviceID || "";
  const svcName = booking?.serviceName || booking?.service || booking?.title || "";
  const svc = (services || []).find((s) => String(s.id || s.serviceId || "") === String(svcId));

  const candidates = [
    svcId,
    svcName,
    svc?.id,
    svc?.serviceId,
    svc?.name,
    svc?.title,
    svc?.slug,
    svc?.path,
  ]
    .map(normalizeServiceKey)
    .filter(Boolean);

  return candidates.some((k) => assigned.includes(k));
}

function parseAvailabilityMinute(value) {
  const m = String(value || "").match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  const hh = Number(m[1]);
  const mm = Number(m[2]);
  if (hh < 0 || hh > 23 || mm < 0 || mm > 59) return null;
  return hh * 60 + mm;
}

function bookingStartDate(b) {
  try {
    if (!b) return null;
    if (b.scheduledAt && typeof b.scheduledAt.toDate === "function") return b.scheduledAt.toDate();
    if (b.scheduledAt) {
      const d = new Date(b.scheduledAt);
      if (!Number.isNaN(d.getTime())) return d;
    }
    if (b.date && b.time) {
      const d = new Date(`${b.date}T${b.time}`);
      if (!Number.isNaN(d.getTime())) return d;
    }
    return null;
  } catch (_) {
    return null;
  }
}

function bookingEndDate(b) {
  const start = bookingStartDate(b);
  if (!start) return null;
  const duration = Number(b?.duration || b?.durationMins || b?.minutes || 60) || 60;
  return new Date(start.getTime() + duration * 60000);
}

function sameCalendarDay(a, b) {
  if (!a || !b) return false;
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}

const DOW_KEYS_ASSIGN = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

function employeeAvailableForBooking(emp, booking) {
  const start = bookingStartDate(booking);
  const end = bookingEndDate(booking);
  if (!start || !end) return true;

  const availability = emp?.availability && typeof emp.availability === "object" ? emp.availability : null;
  if (!availability) return true;

  const ranges = Array.isArray(availability[DOW_KEYS_ASSIGN[start.getDay()]])
    ? availability[DOW_KEYS_ASSIGN[start.getDay()]]
    : [];

  // Backwards compatible: no configured availability means available.
  if (ranges.length === 0) return true;

  const startMin = start.getHours() * 60 + start.getMinutes();
  const endMin = end.getHours() * 60 + end.getMinutes();

  return ranges.some((r) => {
    const from = parseAvailabilityMinute(r?.from);
    const to = parseAvailabilityMinute(r?.to);
    if (from == null || to == null || to <= from) return false;
    return startMin >= from && endMin <= to;
  });
}

function employeeHasBookingConflict(emp, booking, bookings = []) {
  const empId = String(emp?.id || emp?.employeeId || "");
  if (!empId) return false;

  const start = bookingStartDate(booking);
  const end = bookingEndDate(booking);
  if (!start || !end) return false;

  return (bookings || []).some((b) => {
    if (!b || String(b.id || "") === String(booking?.id || "")) return false;

    const status = String(b.status || "").toLowerCase();
    if (["cancelled", "canceled", "rejected", "no-show"].includes(status)) return false;

    const bEmpId = String(b.employeeId || b.workerId || b.resourceId || "");
    if (bEmpId !== empId) return false;

    const bs = bookingStartDate(b);
    const be = bookingEndDate(b);
    if (!bs || !be) return false;

    return start < be && end > bs;
  });
}

function isUnassignedBooking(b) {
  const assignmentStatus = String(b?.assignmentStatus || "").toLowerCase();
  const requestedMode = String(b?.requestedWorkerMode || "").toLowerCase();
  const rawWorkerLabel = String(b?.employeeName || b?.workerName || "").toLowerCase();
  const emp = b?.employeeId || b?.workerId || b?.resourceId;

  if (assignmentStatus === "unassigned") return true;
  if (requestedMode === "any") return true;
  if (rawWorkerLabel.includes("cualquiera")) return true;

  return !emp;
}

function friendlyDateTime(b) {
  const d = bookingStartDate(b);
  if (!d) return fmtDateTime(b);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((target - today) / 86400000);
  const day =
    diffDays === 0
      ? "Hoy"
      : diffDays === 1
        ? "Mañana"
        : d.toLocaleDateString("es-PA", { weekday: "short", day: "numeric", month: "short" });

  const time = d.toLocaleTimeString("es-PA", { hour: "2-digit", minute: "2-digit" });
  return `${day} · ${time}`;
}


function money(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value || 0);
  return `$${Number.isFinite(n) ? n : 0}`;
}


function getBookingLocationInfo(booking = {}) {
  const loc = booking.customerLocation || booking.location || booking.deliveryLocation || {};
  const matched = booking.serviceAreaMatched || booking.matchedServiceArea || booking.coverageAreaMatched || {};
  const exact = String(
    booking.customerExactAddress ||
    booking.customerAddressDetails ||
    booking.addressReference ||
    booking.exactAddress ||
    booking.addressDetails ||
    booking.deliveryAddress ||
    booking.customerAddress ||
    booking.notes ||
    ""
  ).trim();

  const zone = String(
    loc.label ||
    matched.label ||
    booking.customerLocationLabel ||
    booking.serviceAreaLabel ||
    booking.deliveryZone ||
    booking.zoneLabel ||
    booking.coverageArea ||
    booking.serviceArea ||
    ""
  ).trim();

  const modeRaw = String(booking.visitMode || booking.visitTypeLocation || booking.serviceMode || booking.attentionMode || "").toLowerCase();
  const isDelivery =
    ["delivery", "domicilio", "a domicilio", "home"].includes(modeRaw) ||
    Boolean(booking.customerLocation || booking.serviceAreaMatched || booking.customerExactAddress || booking.customerAddressDetails || booking.deliveryAddress);

  const fee = Number(booking.deliveryFee ?? booking.locationFee ?? booking.locationPrice ?? matched.extraFee ?? matched.fee ?? 0);
  return { isDelivery, modeLabel: isDelivery ? "A domicilio" : "En local", zone, exact, fee: Number.isFinite(fee) ? fee : 0 };
}


function BookingPriceBreakdown({ booking }) {
  const [open, setOpen] = React.useState(false);
  const details = getBookingEventDetails(booking);
  const loc = getBookingLocationInfo(booking);
  const servicePrice = Number(
    booking.servicePrice ??
    booking.basePrice ??
    booking.durationPrice ??
    details.durationPrice ??
    booking.price ??
    0
  );
  const extrasPrice = Number(booking.charactersPrice ?? details.charactersPrice ?? booking.extrasPrice ?? 0);
  const deliveryFee = Number(booking.deliveryFee ?? booking.locationFee ?? loc.fee ?? 0);
  const total = Number(booking.totalPrice ?? booking.total ?? booking.amount ?? (servicePrice + extrasPrice + deliveryFee));

  return (
    <div className="mt-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-xs font-black text-slate-700">
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between text-left font-black text-slate-800">
        <span>Total: {money(total)}</span>
        <span className="text-emerald-700">{open ? "Ocultar" : "Ver detalle"}</span>
      </button>
      {open ? (
        <div className="mt-2 grid gap-1 border-t border-slate-100 pt-2 text-[11px]">
          {servicePrice > 0 ? <div className="flex justify-between"><span>Servicio/base</span><strong>{money(servicePrice)}</strong></div> : null}
          {extrasPrice > 0 ? <div className="flex justify-between"><span>Extras/personajes</span><strong>{money(extrasPrice)}</strong></div> : null}
          {deliveryFee > 0 ? <div className="flex justify-between"><span>Zona/domicilio</span><strong>{money(deliveryFee)}</strong></div> : null}
          <div className="flex justify-between border-t border-slate-100 pt-1 text-slate-950"><span>Total</span><strong>{money(total)}</strong></div>
        </div>
      ) : null}
    </div>
  );
}

function BookingLocationMini({ booking }) {
  const info = getBookingLocationInfo(booking);
  return (
    <div className={`mt-2 rounded-2xl border px-3 py-2 text-xs font-black ${info.isDelivery ? "border-emerald-100 bg-emerald-50 text-emerald-900" : "border-slate-200 bg-slate-50 text-slate-700"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <span className={`rounded-full px-2 py-1 text-[10px] uppercase tracking-wide ${info.isDelivery ? "bg-emerald-600 text-white" : "bg-slate-700 text-white"}`}>{info.modeLabel}</span>
        {info.zone ? <span>{info.zone}</span> : null}
        {info.fee > 0 ? <span className="text-emerald-700">+${info.fee}</span> : null}
      </div>
      {info.exact ? <div className="mt-2 rounded-xl bg-white/75 px-2 py-2 text-[11px] font-bold leading-4 text-slate-700"><span className="font-black text-slate-500">Dirección exacta:</span> {info.exact}</div> : null}
    </div>
  );
}

function normalizeVisitTypeLabel(value) {
  const raw = String(value || "").trim();
  const key = raw.toLowerCase();

  if (!raw) return "";
  if (key === "show" || key.includes("show")) return "Show completo";
  if (key === "visit" || key.includes("visita")) return "Solo visita";
  if (key === "photos" || key.includes("foto")) return "Fotos y saludo";

  return raw;
}

function getBookingEventDetails(booking = {}) {
  const details = booking.eventDetails || {};
  const options = booking.eventOptions || {};

  const selectedCharacters =
    Array.isArray(details.selectedCharacters) ? details.selectedCharacters :
    Array.isArray(options.selectedCharacters) ? options.selectedCharacters :
    Array.isArray(booking.selectedCharacters) ? booking.selectedCharacters :
    Array.isArray(booking.charactersSelected) ? booking.charactersSelected :
    [];

  const selectedCharacterIds =
    Array.isArray(details.selectedCharacterIds) ? details.selectedCharacterIds :
    Array.isArray(options.selectedCharacterIds) ? options.selectedCharacterIds :
    Array.isArray(booking.selectedCharacterIds) ? booking.selectedCharacterIds :
    Array.isArray(booking.characterIds) ? booking.characterIds :
    [];

  const flatExtras =
    booking.extras ||
    booking.addons ||
    booking.eventExtras ||
    booking.plus ||
    booking.pluses ||
    null;

  const visitTypeRaw =
    details.visitTypeLabel ||
    details.visitType ||
    options.visitTypeLabel ||
    options.visitType ||
    booking.visitTypeLabel ||
    booking.visitType ||
    booking.eventType ||
    booking.packageType ||
    "";

  const visitHours =
    details.visitHours ||
    options.visitHours ||
    booking.visitHours ||
    booking.hours ||
    booking.eventHours ||
    null;

  const durationPrice =
    details.durationPrice ??
    options.durationPrice ??
    booking.durationPrice ??
    booking.basePrice ??
    booking.priceBase ??
    null;

  const charactersPrice =
    details.charactersPrice ??
    options.charactersPrice ??
    booking.charactersPrice ??
    booking.extrasPrice ??
    booking.addonsPrice ??
    null;

  const totalPrice =
    booking.totalPrice ??
    booking.total ??
    booking.amount ??
    booking.priceTotal ??
    details.totalPrice ??
    options.totalPrice ??
    null;

  const isEvent = Boolean(
    booking.eventDetails ||
    booking.eventOptions ||
    totalPrice != null ||
    visitTypeRaw ||
    visitHours ||
    selectedCharacters.length ||
    selectedCharacterIds.length ||
    flatExtras ||
    booking.assignmentStatus === "not_required" ||
    booking.employeeNotRequired === true
  );

  return {
    isEvent,
    visitTypeLabel: normalizeVisitTypeLabel(visitTypeRaw),
    visitHours,
    selectedCharacters,
    selectedCharacterIds,
    flatExtras,
    durationPrice,
    charactersPrice,
    totalPrice,
  };
}

function eventExtrasText(details) {
  if (!details) return "Sin extras";

  if (details.selectedCharacters?.length) {
    return details.selectedCharacters
      .map((c) => {
        if (!c) return "";
        if (typeof c === "string") return c;
        const price = c.price != null && Number(c.price || 0) > 0 ? ` (${money(c.price)})` : "";
        return `${c.name || c.id || "Extra"}${price}`;
      })
      .filter(Boolean)
      .join(", ");
  }

  if (details.selectedCharacterIds?.length) {
    return details.selectedCharacterIds.join(", ");
  }

  if (Array.isArray(details.flatExtras)) {
    return details.flatExtras.map((x) => typeof x === "string" ? x : (x?.name || x?.label || x?.id)).filter(Boolean).join(", ") || "Sin extras";
  }

  if (details.flatExtras && typeof details.flatExtras === "object") {
    return Object.values(details.flatExtras).map((x) => typeof x === "string" ? x : (x?.name || x?.label || x?.id)).filter(Boolean).join(", ") || "Sin extras";
  }

  if (typeof details.flatExtras === "string") return details.flatExtras;

  return "Sin extras";
}

function EventBookingMiniDetails({ booking }) {
  const details = getBookingEventDetails(booking);
  if (!details.isEvent) return null;

  const total = details.totalPrice != null ? money(details.totalPrice) : "";
  const base = details.durationPrice != null ? money(details.durationPrice) : "";
  const extrasPrice = details.charactersPrice != null ? money(details.charactersPrice) : "";

  return (
    <div className="mt-2 rounded-2xl border border-emerald-100 bg-emerald-50/70 px-3 py-2 text-xs font-black text-emerald-800">
      <div>
        {details.visitTypeLabel || "Evento"}
        {details.visitHours ? ` · ${details.visitHours}h` : booking.duration ? ` · ${booking.duration} min` : ""}
      </div>
      <div className="mt-1 text-emerald-700/90">Extras: {eventExtrasText(details)}</div>
      {(base || extrasPrice) ? (
        <div className="mt-1 text-emerald-700/90">
          {base ? `Base ${base}` : ""}
          {base && extrasPrice ? " · " : ""}
          {extrasPrice ? `Extras ${extrasPrice}` : ""}
        </div>
      ) : null}
      {total ? <div className="mt-1 text-emerald-900">Total: {total}</div> : null}
      {!total ? <div className="mt-1 text-amber-700">Total no guardado en la reserva</div> : null}
    </div>
  );
}


function getBookingTotalValue(booking = {}) {
  const details = getBookingEventDetails(booking);
  const loc = getBookingLocationInfo(booking);
  const servicePrice = Number(
    booking.servicePrice ??
    booking.basePrice ??
    booking.durationPrice ??
    details.durationPrice ??
    booking.price ??
    0
  );
  const extrasPrice = Number(booking.charactersPrice ?? details.charactersPrice ?? booking.extrasPrice ?? 0);
  const deliveryFee = Number(booking.deliveryFee ?? booking.locationFee ?? loc.fee ?? 0);
  const total = Number(booking.totalPrice ?? booking.total ?? booking.amount ?? (servicePrice + extrasPrice + deliveryFee));
  return Number.isFinite(total) ? total : 0;
}

function getBookingServicePreview(booking = {}) {
  const details = getBookingEventDetails(booking);
  const serviceName = booking.serviceName || booking.service || "Servicio";
  if (!details.isEvent) return serviceName;

  const parts = [];
  if (details.visitTypeLabel) parts.push(details.visitTypeLabel);
  if (details.visitHours) parts.push(`${details.visitHours}h`);
  const charsCount = (details.selectedCharacters || []).length || (details.selectedCharacterIds || []).length;
  if (charsCount) parts.push(`${charsCount} personaje${charsCount === 1 ? "" : "s"}`);

  return parts.length ? `${serviceName} · ${parts.join(" · ")}` : serviceName;
}

function BookingPreviewLine({ booking }) {
  const loc = getBookingLocationInfo(booking);
  const total = getBookingTotalValue(booking);
  return (
    <div className="mt-2 grid gap-1 text-xs font-black">
      <div className="text-slate-500">{friendlyDateTime(booking)}</div>
      <div className={`${loc.isDelivery ? "text-emerald-700" : "text-slate-600"}`}>
        {loc.isDelivery ? "A domicilio" : "En local"}{loc.zone ? ` · ${loc.zone}` : ""}
      </div>
      <div className="text-slate-950">Total: {money(total)}</div>
    </div>
  );
}

function BookingCostDetailCard({ booking }) {
  const details = getBookingEventDetails(booking);
  const loc = getBookingLocationInfo(booking);
  const servicePrice = Number(
    booking.servicePrice ??
    booking.basePrice ??
    booking.durationPrice ??
    details.durationPrice ??
    booking.price ??
    0
  );
  const extrasPrice = Number(booking.charactersPrice ?? details.charactersPrice ?? booking.extrasPrice ?? 0);
  const deliveryFee = Number(booking.deliveryFee ?? booking.locationFee ?? loc.fee ?? 0);
  const total = getBookingTotalValue(booking);

  return (
    <div className="mx-4 mb-4 rounded-3xl border border-emerald-100 bg-emerald-50/70 p-4 text-sm">
      <div className="mb-3 text-[11px] font-black uppercase tracking-[0.14em] text-emerald-700">Detalle del costo</div>
      <div className="grid gap-2">
        {servicePrice > 0 ? (
          <div className="flex justify-between gap-4">
            <span className="font-bold text-slate-600">Servicio/base</span>
            <strong className="text-slate-950">{money(servicePrice)}</strong>
          </div>
        ) : null}
        {extrasPrice > 0 ? (
          <div className="flex justify-between gap-4">
            <span className="font-bold text-slate-600">Extras/personajes</span>
            <strong className="text-slate-950">{money(extrasPrice)}</strong>
          </div>
        ) : null}
        {deliveryFee > 0 ? (
          <div className="flex justify-between gap-4">
            <span className="font-bold text-slate-600">Zona/domicilio</span>
            <strong className="text-slate-950">{money(deliveryFee)}</strong>
          </div>
        ) : null}
        <div className="mt-1 flex justify-between gap-4 border-t border-emerald-100 pt-3">
          <span className="font-black text-slate-950">Total</span>
          <strong className="text-emerald-700">{money(total)}</strong>
        </div>
      </div>
    </div>
  );
}


function workerLabelForBooking(b, employees = []) {
  const assignmentStatus = String(b?.assignmentStatus || "").toLowerCase();
  const requestedMode = String(b?.requestedWorkerMode || "").toLowerCase();

  if (
    assignmentStatus === "not_required" ||
    requestedMode === "none" ||
    requestedMode === "not_required" ||
    b?.employeeNotRequired === true ||
    b?.noWorkerRequired === true
  ) {
    return "No requiere trabajador";
  }

  if (isUnassignedBooking(b)) return "Sin asignar";

  const id = String(b?.employeeId || b?.workerId || b?.resourceId || "");
  const emp = id ? (employees || []).find((e) => String(e.id || e.employeeId || "") === id) : null;
  const name = b?.employeeName || b?.workerName || emp?.name || emp?.displayName || "";
  if (name) return name;
  return "Trabajador";
}

function AssignWorkerModal({ open, booking, workers, onClose, onAssign, onSkip, loading, multi = false }) {
  const [selectedIds, setSelectedIds] = React.useState([]);

  React.useEffect(() => {
    if (open) setSelectedIds([]);
  }, [open, booking?.id]);

  if (!open || !booking) return null;

  const toggle = (worker) => {
    const id = String(worker.id || worker.employeeId || "");
    if (!id) return;
    setSelectedIds((prev) => {
      const set = new Set((prev || []).map(String));
      if (set.has(id)) set.delete(id);
      else set.add(id);
      return Array.from(set);
    });
  };

  const selectedWorkers = (workers || []).filter((w) => selectedIds.includes(String(w.id || w.employeeId || "")));

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-slate-950/55 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-xl overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-2xl">
        <div className="px-6 py-5" style={{ background: "linear-gradient(135deg, rgba(0,103,95,0.12), #ffffff 68%)" }}>
          <div className="mb-2 text-[11px] font-black uppercase tracking-[0.16em] text-emerald-700">Asignar equipo</div>
          <h3 className="text-2xl font-black tracking-tight text-slate-950">{multi ? "¿Quiénes trabajarán esta reserva?" : "¿Quién atenderá esta reserva?"}</h3>
          <p className="mt-2 text-sm font-semibold leading-6 text-slate-500">
            {multi ? "Puedes asignar una o varias personas del equipo operativo. Esto no afecta la disponibilidad del servicio." : "Solo mostramos trabajadores que hacen este servicio y están disponibles en ese horario."}
          </p>
          <div className="mt-3 rounded-2xl border border-slate-200 bg-white/80 p-3 text-sm font-bold text-slate-700">
            {booking.serviceName || "Servicio"} · {friendlyDateTime(booking)}
          </div>
        </div>

        <div className="max-h-[46vh] overflow-auto p-4">
          {workers.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-4 text-sm font-bold text-slate-500">
              No encontré trabajadores disponibles. Puedes confirmar sin equipo y asignarlo después.
            </div>
          ) : (
            <div className="grid gap-2">
              {workers.map((w) => {
                const id = String(w.id || w.employeeId || "");
                const active = selectedIds.includes(id);
                return (
                  <button
                    key={id}
                    type="button"
                    disabled={loading}
                    onClick={() => multi ? toggle(w) : onAssign(w)}
                    className={`flex w-full items-center justify-between rounded-2xl border px-4 py-3 text-left transition active:scale-[0.99] ${active ? "border-emerald-300 bg-emerald-50" : "border-slate-200 bg-white hover:border-emerald-200 hover:bg-emerald-50"}`}
                  >
                    <span>
                      <span className="block text-sm font-black text-slate-900">{w.name || w.displayName || w.email || "Trabajador"}</span>
                      <span className="block text-xs font-bold text-slate-500">{w.email || "Disponible"}</span>
                    </span>
                    <span className={`rounded-full px-3 py-2 text-xs font-black ${active ? "bg-emerald-600 text-white" : "bg-slate-100 text-slate-600"}`}>{multi ? (active ? "Seleccionado" : "Elegir") : "Asignar"}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="grid gap-3 border-t border-slate-100 p-4 sm:grid-cols-3">
          <button type="button" onClick={onClose} className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700">
            Cancelar
          </button>
          {multi ? (
            <button type="button" disabled={loading || selectedWorkers.length === 0} onClick={() => onAssign(selectedWorkers)} className="rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-black text-white disabled:opacity-50">
              Asignar equipo
            </button>
          ) : null}
          <button type="button" disabled={loading} onClick={onSkip} className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-black text-emerald-700">
            Confirmar sin equipo
          </button>
        </div>
      </div>
    </div>
  );
}

function CustomerDetailModal({ booking, stats, onClose, employees = [] }) {
  if (!booking) return null;

  const rows = [
    ["Nombre", booking.customerName || "Cliente"],
    ["Correo", booking.customerEmail || "No registrado"],
    ["Teléfono", booking.customerPhone || booking.phone || booking.customerSnapshot?.phone || "No registrado"],
    ["Edad", booking.customerAge || booking.age || booking.customerSnapshot?.age || "No registrada"],
    ["Servicio", booking.serviceName || booking.service || "Servicio"],
    ["Atención", getBookingLocationInfo(booking).modeLabel],
    ["Zona", getBookingLocationInfo(booking).zone ? `${getBookingLocationInfo(booking).zone}${getBookingLocationInfo(booking).fee > 0 ? ` · +$${getBookingLocationInfo(booking).fee}` : ""}` : ""],
    ["Dirección exacta", getBookingLocationInfo(booking).exact],
    ["Tipo", getBookingEventDetails(booking).isEvent ? (getBookingEventDetails(booking).visitTypeLabel || "Experiencia") : ""],
    ["Duración", getBookingEventDetails(booking).isEvent && getBookingEventDetails(booking).visitHours ? `${getBookingEventDetails(booking).visitHours}h` : ""],
    ["Extras", getBookingEventDetails(booking).isEvent ? ((getBookingEventDetails(booking).selectedCharacters || []).map((c) => c.name || c.id).filter(Boolean).join(", ") || (getBookingEventDetails(booking).selectedCharacterIds || []).join(", ") || "Sin extras") : ""],
    ["Total", getBookingEventDetails(booking).totalPrice != null ? money(getBookingEventDetails(booking).totalPrice) : ""],
    ["Fecha", friendlyDateTime(booking)],
    ["Trabajador", workerLabelForBooking(booking, employees)],
    ["Gestión", "Asistencia y pagos se actualizan desde Agenda"],
  ];

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-slate-950/55 backdrop-blur-sm" onClick={onClose} />
      <div className="pending-detail-modal-shell relative w-full max-w-md overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-2xl">
        <div className="px-6 py-5" style={{ background: "linear-gradient(135deg, rgba(0,103,95,0.12), #ffffff 68%)" }}>
          <div className="mb-2 text-[11px] font-black uppercase tracking-[0.16em] text-emerald-700">Detalle de reserva</div>
          <h3 className="text-2xl font-black tracking-tight text-slate-950">{booking.customerName || "Cliente"}</h3>
          <p className="mt-2 text-sm font-semibold text-slate-500">Información completa de la reserva, cliente, ubicación y costos.</p>
        </div>
        <div className="pending-detail-modal-body grid gap-2 p-4">
          {rows.map(([label, value]) => (
            <div key={label} className="grid grid-cols-[110px_1fr] gap-3 rounded-2xl bg-slate-50 px-3 py-2 text-sm">
              <span className="font-black text-slate-500">{label}</span>
              <span className="font-bold text-slate-900 break-words">{String(value || "-")}</span>
            </div>
          ))}
        </div>
        <BookingCostDetailCard booking={booking} />
        <div className="border-t border-slate-100 p-4">
          <button type="button" onClick={onClose} className="w-full rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-black text-white">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}


function getEffectiveAdminUser(user) {
  if (user && (user.uid || user.email)) return user;
  if (isIosCapacitor()) {
    try {
      const ma = getManualAuth();
      if (ma && isManualAuthLikelyValid(ma)) {
        return { uid: ma.uid || null, email: ma.email || null };
      }
    } catch (_) {}
  }
  return user || null;
}

/* ----------------------
   Main PendingsPanel
   ---------------------- */

export default function PendingsPanel({
  db,
  businessId,
  user,
  isAdmin,
  onBack = () => {},
  onMarkAttendance: onMarkAttendanceProp,
  isNativeRuntime: isNativeProp,
  employees = [],
  services = [],
  allBookings = [],
  businessDoc = null,
  calendarSettings = null,
  onRefresh = null,
  onApprovalModeSaved = null,
  workerScope = false,
  workerEmployeeId = "",
  workerPermissions = null,
  workerProfile = null,
  focusedOnlyForWorker = false,
}) {
  const firestore = db || defaultDb;
  const effectiveAdminUser = getEffectiveAdminUser(user);
  const adminUid = effectiveAdminUser?.uid || null;
  const isWorkerPendingScope = Boolean(workerScope);
  const workerPendingEmployeeId = String(
    workerEmployeeId ||
    workerProfile?.employeeId ||
    workerProfile?.id ||
    workerProfile?.workerId ||
    ""
  ).trim();
  const workerPendingEmployeeName = String(
    workerProfile?.name ||
    workerProfile?.displayName ||
    workerProfile?.employeeName ||
    workerProfile?.workerName ||
    "Trabajador"
  ).trim() || "Trabajador";
  const workerPendingEmployeeEmail = String(
    workerProfile?.email ||
    workerProfile?.emailLower ||
    workerProfile?.employeeEmail ||
    workerProfile?.workerEmail ||
    effectiveAdminUser?.email ||
    ""
  ).trim().toLowerCase();

  // UI state — approval-only queue. Attendance/no-show lives in Agenda detail.
  const [pendingList, setPendingList] = useState([]);
  const [toConfirmList, setToConfirmList] = useState([]); // hidden operational cache used only for worker conflict checks
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [compactFiltersOpen, setCompactFiltersOpen] = useState(false);
  const [filterService, setFilterService] = useState("");
  const [statusMessage, setStatusMessage] = useState(null);
  const [approvalModeDraft, setApprovalModeDraft] = useState("");
  const [approvalModeSaving, setApprovalModeSaving] = useState(false);
  const [approvalModeStatus, setApprovalModeStatus] = useState("");
  const [approvalModeModalOpen, setApprovalModeModalOpen] = useState(false);
  const [approvalModeModalDraft, setApprovalModeModalDraft] = useState("");
  const [approvalModeModalError, setApprovalModeModalError] = useState("");
  const [focusedBookingId, setFocusedBookingId] = useState(() => {
    try {
      if (typeof window === "undefined") return "";
      const params = new URLSearchParams(window.location.search || "");
      return String(params.get("bookingId") || params.get("pendingBookingId") || "").trim();
    } catch (_) {
      return "";
    }
  });

  // modal state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const confirmRef = useRef({}); // { action: fn, title, desc, destructive }
  const [detailBooking, setDetailBooking] = useState(null);
  const [assignBooking, setAssignBooking] = useState(null);
  const [assigningWorker, setAssigningWorker] = useState(false);

  // user stats & realtime user listeners
  const [userStats, setUserStats] = useState({});
  const userListenersRef = useRef({}); // uid -> unsubscribe

  // detect native runtime if not provided
  const isNativeRuntime =
    typeof isNativeProp !== "undefined" ? isNativeProp : typeof window !== "undefined" && !!window.Capacitor;

  const noWorkerMode = Boolean(
    businessDoc?.noWorkers ||
    businessDoc?.noWorkerMode ||
    businessDoc?.withoutWorkers ||
    businessDoc?.businessModel === "no_workers" ||
    businessDoc?.businessModel === "noWorkers" ||
    businessDoc?.eventNoWorkers ||
    ((employees || []).length === 0)
  );

  const serverApprovalMode = (
    calendarSettings?.approvalMode ||
    businessDoc?.calendarSettings?.approvalMode ||
    "manual"
  ) === "auto" ? "auto" : "manual";
  const effectiveApprovalMode = approvalModeDraft || serverApprovalMode;
  const isAutoApprovalMode = effectiveApprovalMode === "auto";

  useEffect(() => {
    if (approvalModeSaving) return;
    setApprovalModeDraft(serverApprovalMode);
  }, [serverApprovalMode, approvalModeSaving]);

  useEffect(() => {
    if (!approvalModeModalOpen) return;
    setApprovalModeModalDraft(effectiveApprovalMode);
    setApprovalModeModalError("");
  }, [approvalModeModalOpen, effectiveApprovalMode]);

  const openApprovalModeModal = useCallback(() => {
    setApprovalModeModalDraft(effectiveApprovalMode);
    setApprovalModeModalError("");
    setApprovalModeModalOpen(true);
  }, [effectiveApprovalMode]);

  const saveApprovalModeFromPending = useCallback(async (nextMode) => {
    const mode = nextMode === "auto" ? "auto" : "manual";
    if (!businessId || !firestore) {
      setApprovalModeModalError("No se encontró el negocio activo para guardar.");
      setApprovalModeStatus("No se pudo guardar");
      return;
    }

    setApprovalModeDraft(mode);
    setApprovalModeSaving(true);
    setApprovalModeStatus("Guardando...");
    setApprovalModeModalError("");

    try {
      const currentSettings = {
        ...(businessDoc?.calendarSettings || {}),
        ...(calendarSettings || {}),
        approvalMode: mode,
      };
      const payload = {
        "calendarSettings.approvalMode": mode,
        calendarSettingsUpdatedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };
      if (isIosCapacitor() && typeof fsClient.updateDocByPath === "function") {
        await fsClient.updateDocByPath(`businesses/${businessId}`, payload, { db: firestore });
      } else {
        await updateDoc(doc(firestore, "businesses", String(businessId)), payload);
      }

      setApprovalModeStatus(mode === "auto" ? "Automático guardado" : "Manual guardado");
      setApprovalModeModalOpen(false);
      if (typeof onApprovalModeSaved === "function") onApprovalModeSaved(mode, currentSettings);
      if (typeof onRefresh === "function") onRefresh();
      try {
        window.__LOOP_PENDING_APPROVAL_MODE_LAST_SAVE__ = {
          businessId,
          approvalMode: mode,
          source: "PendingsPanel",
          payloadMode: "calendarSettings.approvalMode",
          time: new Date().toISOString(),
        };
      } catch (_) {}
    } catch (err) {
      console.error("PendingsPanel: save approval mode failed", err);
      setApprovalModeDraft(serverApprovalMode);
      setApprovalModeModalError("No se pudo guardar. Revisa permisos o conexión e intenta de nuevo.");
      setApprovalModeStatus("No se pudo guardar");
    } finally {
      setApprovalModeSaving(false);
    }
  }, [businessId, firestore, businessDoc, calendarSettings, onRefresh, onApprovalModeSaved, serverApprovalMode]);

  const bookingDoesNotRequireWorker = useCallback(
    (booking) => {
      if (noWorkerMode) return true;

      const requestedMode = String(booking?.requestedWorkerMode || "").toLowerCase();
      const assignmentStatus = String(booking?.assignmentStatus || "").toLowerCase();

      return (
        requestedMode === "none" ||
        requestedMode === "not_required" ||
        assignmentStatus === "not_required" ||
        booking?.employeeNotRequired === true ||
        booking?.noWorkerRequired === true
      );
    },
    [noWorkerMode]
  );

  /* ----------------------
     Firestore helpers (kept from original)
     ---------------------- */
  const computeUserStatsFromBookings = useCallback(
    async (uid) => {
      try {
        const qg = query(collectionGroup(firestore, "bookings"), where("userId", "==", uid));
        const snap = await getDocs(qg);
        let total = 0,
          attended = 0;
        snap.forEach((d) => {
          const data = d.data() || {};
          const status = (data.status || "").toString().toLowerCase();
          if (status === "cancelled" || status === "rejected") return;
          total += 1;
          if (status === "attended") attended += 1;
        });
        const percent = total > 0 ? Math.round((attended / total) * 100) : 0;
        return { attendedCount: attended, totalCount: total, attendancePercent: percent };
      } catch (err) {
        console.error("PendingsPanel: computeUserStatsFromBookings error", uid, err);
        return { attendedCount: 0, totalCount: 0, attendancePercent: 0 };
      }
    },
    [firestore]
  );

  const loadUserStats = useCallback(
    async (userIds) => {
      if (!userIds || userIds.length === 0) return;
      const map = {};
      await Promise.all(
        userIds.map(async (uid) => {
          try {
            const uRef = doc(firestore, "users", uid);
            const snap = await getDoc(uRef);
            if (snap.exists()) {
              const d = snap.data();
              map[uid] = {
                attendedCount: Number(d.attendedCount || 0),
                totalCount: Number(d.totalCount || 0),
                attendancePercent: Number(
                  d.attendancePercent ?? (d.attendedCount && d.totalCount ? Math.round((Number(d.attendedCount || 0) / Number(d.totalCount || 0)) * 100) : 0)
                ),
              };
            } else {
              const fallback = await computeUserStatsFromBookings(uid);
              map[uid] = fallback;
            }
          } catch (err) {
            console.warn("PendingsPanel: loadUserStats error", uid, err);
            const fallback = await computeUserStatsFromBookings(uid);
            map[uid] = fallback;
          }
        })
      );
      setUserStats((prev) => ({ ...prev, ...map }));
    },
    [firestore, computeUserStatsFromBookings]
  );

  const ensureUserListeners = useCallback(
    (userIds) => {
      if (isIosCapacitor()) return;
      if (!userIds) userIds = [];
      const current = userListenersRef.current || {};
      const wanted = new Set(userIds.filter(Boolean));

      // unsubscribe those not wanted
      Object.keys(current).forEach((uid) => {
        if (!wanted.has(uid)) {
          try {
            current[uid]();
          } catch (e) {}
          delete current[uid];
        }
      });

      // subscribe missing
      userIds.forEach((uid) => {
        if (!uid) return;
        if (current[uid]) return;
        const uRef = doc(firestore, "users", uid);
        try {
          const unsub = onSnapshot(
            uRef,
            async (snap) => {
              if (!snap.exists()) {
                const fallback = await computeUserStatsFromBookings(uid);
                setUserStats((prev) => ({ ...prev, [uid]: fallback }));
                return;
              }
              const d = snap.data() || {};
              const attendedCount = Number(d.attendedCount || 0);
              const totalCount = Number(d.totalCount || 0);
              const percent = Number(d.attendancePercent ?? (totalCount > 0 ? Math.round((attendedCount / totalCount) * 100) : 0));
              setUserStats((prev) => ({ ...prev, [uid]: { attendedCount, totalCount, attendancePercent: percent } }));
            },
            async (err) => {
              console.warn("PendingsPanel: user onSnapshot error for", uid, err);
              try {
                current[uid] && current[uid]();
              } catch (_) {}
              delete current[uid];
              const fallback = await computeUserStatsFromBookings(uid);
              setUserStats((prev) => ({ ...prev, [uid]: fallback }));
            }
          );
          current[uid] = unsub;
        } catch (e) {
          console.warn("PendingsPanel: failed to create onSnapshot for", uid, e);
        }
      });

      userListenersRef.current = current;
    },
    [firestore, computeUserStatsFromBookings]
  );

  const cleanupUserListeners = useCallback(() => {
    const current = userListenersRef.current || {};
    Object.keys(current).forEach((uid) => {
      try {
        current[uid]();
      } catch (e) {}
    });
    userListenersRef.current = {};
  }, []);

  function pendingPanelBookingId(value = {}) {
    return String(value?.id || value?.bookingId || value?._id || "").trim();
  }

  function pendingPanelStatus(value = {}) {
    return String(value?.status || value?.confirmationStatus || value?.bookingStatus || value?.state || "").trim().toLowerCase();
  }

  function pendingPanelIsPending(value = {}) {
    return ["pending", "to_confirm", "pendiente", "por_confirmar"].includes(pendingPanelStatus(value));
  }

  function pendingPanelIsConfirmed(value = {}) {
    return ["confirmed", "accepted", "approved", "confirmada", "aprobada"].includes(pendingPanelStatus(value));
  }

  function pendingPanelBookingEmployeeIds(value = {}) {
    const ids = [
      value.employeeId, value.workerId, value.resourceId, value.assignedEmployeeId,
      value.employee?.id, value.worker?.id, value.resource?.id,
    ];
    if (Array.isArray(value.assignedEmployeeIds)) ids.push(...value.assignedEmployeeIds);
    if (Array.isArray(value.employeeIds)) ids.push(...value.employeeIds);
    if (Array.isArray(value.workerIds)) ids.push(...value.workerIds);
    return Array.from(new Set(ids.map((x) => String(x || "").trim()).filter(Boolean)));
  }

  function pendingPanelBookingMatchesWorker(value = {}) {
    if (!isWorkerPendingScope) return true;
    const bookingId = pendingPanelBookingId(value);
    if (focusedBookingId && bookingId && String(bookingId) === String(focusedBookingId)) return true;
    if (!workerPendingEmployeeId) return false;
    return pendingPanelBookingEmployeeIds(value).includes(workerPendingEmployeeId);
  }

  function pendingPanelWorkerVisibleRows(rows = []) {
    const source = Array.isArray(rows) ? rows : [];
    const focused = String(focusedBookingId || "").trim();
    if (isWorkerPendingScope && focused && focusedOnlyForWorker) {
      return source.filter((b) => String(pendingPanelBookingId(b)) === focused);
    }
    if (!isWorkerPendingScope) return source;
    return source.filter((b) => pendingPanelBookingMatchesWorker(b));
  }

  /* ----------------------
     Bookings subscriptions
     ---------------------- */
  useEffect(() => {
    if ((!isAdmin && !isWorkerPendingScope) || !businessId) {
      setPendingList([]);
      setToConfirmList([]);
      setUserStats({});
      setLoading(false);
      cleanupUserListeners();
      return;
    }

    if (isWorkerPendingScope) {
      const rows = Array.isArray(allBookings) ? allBookings.map((b) => ({ id: b.id || b.bookingId || b._id, ...(b || {}) })) : [];
      const pending = pendingPanelWorkerVisibleRows(rows.filter(pendingPanelIsPending))
        .sort((a, b) => (timestampToMillis(b.createdAt) || timestampToMillis(b.scheduledAt) || 0) - (timestampToMillis(a.createdAt) || timestampToMillis(a.scheduledAt) || 0));
      const confirmed = pendingPanelWorkerVisibleRows(rows.filter(pendingPanelIsConfirmed))
        .sort((a, b) => (timestampToMillis(b.scheduledAt) || 0) - (timestampToMillis(a.scheduledAt) || 0));
      setPendingList(pending);
      setToConfirmList(confirmed);
      setLoading(false);
      try {
        window.__LOOP_WORKER_PENDING_PANEL_DEBUG__ = {
          stage: "worker_scope_v15",
          businessId,
          workerEmployeeId: workerPendingEmployeeId || null,
          focusedBookingId: focusedBookingId || null,
          sourceCount: rows.length,
          pendingCount: pending.length,
          at: new Date().toISOString(),
        };
      } catch (_) {}
      return;
    }

    setLoading(true);
    let unsubPending = () => {};
    let unsubConfirm = () => {};
    let mounted = true;

    if (isIosCapacitor()) {
      (async () => {
        try {
          const rows = await fsClient.listCollectionByPath(`businesses/${businessId}/bookings`, {}, { db: firestore });
          if (!mounted) return;
          const all = Array.isArray(rows) ? rows.map((r) => ({ id: r.id || r.bookingId || r._id, ...(r || {}) })) : [];
          const pending = all
            .filter((b) => String(b.status || "").toLowerCase() === "pending")
            .sort((a, b) => (timestampToMillis(b.createdAt) || 0) - (timestampToMillis(a.createdAt) || 0));

          const confirmed = all
            .filter((b) => String(b.status || "").toLowerCase() === "confirmed")
            .sort((a, b) => (timestampToMillis(b.scheduledAt) || 0) - (timestampToMillis(a.scheduledAt) || 0));

          setPendingList(pending);
          // Hidden cache only. The UI no longer shows attendance/no-show confirmation in this panel.
          setToConfirmList(confirmed);

          const userIds = Array.from(new Set(pending.map((b) => b.userId).filter(Boolean)));
          if (userIds.length > 0) {
            await loadUserStats(userIds);
          } else {
            setUserStats({});
          }
        } catch (err) {
          console.error("PendingsPanel: iOS pending load error", err);
        } finally {
          if (mounted) setLoading(false);
        }
      })();

      return () => {
        mounted = false;
        cleanupUserListeners();
      };
    }

    try {
      const pendingQ = query(collection(firestore, `businesses/${businessId}/bookings`), where("status", "==", "pending"), orderBy("createdAt", "desc"));
      unsubPending = onSnapshot(
        pendingQ,
        (snap) => {
          const p = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
          setPendingList(p);
          const userIds = Array.from(new Set(p.map((b) => b.userId).filter(Boolean)));
          if (userIds.length > 0) {
            loadUserStats(userIds).catch((e) => console.error("loadUserStats error", e));
            ensureUserListeners(userIds);
          } else {
            cleanupUserListeners();
            setUserStats({});
          }
        },
        (err) => {
          console.error("PendingsPanel: pending onSnapshot error", err);
        }
      );

      const confirmQ = query(collection(firestore, `businesses/${businessId}/bookings`), where("status", "==", "confirmed"), orderBy("scheduledAt", "desc"));
      unsubConfirm = onSnapshot(
        confirmQ,
        (snap) => {
          // Hidden cache only for assignment conflict checks. Attendance is handled from Agenda detail.
          setToConfirmList(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        },
        (err) => {
          console.error("PendingsPanel: confirmed cache onSnapshot error", err);
        }
      );

      setLoading(false);
    } catch (err) {
      console.error("PendingsPanel: Error setting up snapshots", err);
      setLoading(false);
      cleanupUserListeners();
    }

    return () => {
      mounted = false;
      try {
        unsubPending();
      } catch (e) {}
      try {
        unsubConfirm();
      } catch (e) {}
      cleanupUserListeners();
    };
  }, [firestore, businessId, isAdmin, loadUserStats, ensureUserListeners, cleanupUserListeners]);

  // keep stats/listeners in sync (race protection)
  useEffect(() => {
    const userIds = Array.from(new Set([...(pendingList || []).map((b) => b.userId)].filter(Boolean)));
    if (userIds.length > 0) {
      loadUserStats(userIds).catch((e) => console.error("loadUserStats error", e));
      ensureUserListeners(userIds);
    } else {
      cleanupUserListeners();
      setUserStats({});
    }
  }, [pendingList, loadUserStats, ensureUserListeners, cleanupUserListeners]);

  /* ----------------------
     Action handlers
     ---------------------- */
  async function isCurrentUserOwnerOrAdmin() {
    try {
      let biz = null;
      if (isIosCapacitor()) {
        biz = await fsClient.getDocByPath(`businesses/${businessId}`, { db: firestore });
      } else {
        const bizRef = doc(firestore, "businesses", businessId);
        const bizSnap = await getDoc(bizRef);
        if (!bizSnap.exists()) return false;
        biz = bizSnap.data();
      }
      if (!biz) return false;
      if (biz.ownerUid && adminUid && biz.ownerUid === adminUid) return true;
      if (adminUid) {
        if (isIosCapacitor()) {
          const adminSnap = await fsClient.getDocByPath(`businesses/${businessId}/admins/${adminUid}`, { db: firestore });
          if (adminSnap) return true;
        } else {
          const adminRef = doc(firestore, `businesses/${businessId}/admins`, adminUid);
          const adminSnap = await getDoc(adminRef);
          if (adminSnap.exists()) return true;
        }
      }
      return false;
    } catch (err) {
      console.error("PendingsPanel: Error checking owner/admin status", err);
      return false;
    }
  }


  const getAvailableWorkersForBooking = useCallback(
    (booking) => {
      const sourceBookings = [
        ...(Array.isArray(allBookings) ? allBookings : []),
        ...(Array.isArray(toConfirmList) ? toConfirmList : []),
        ...(Array.isArray(pendingList) ? pendingList : []),
      ];

      return (employees || [])
        .filter((emp) => !emp?.disabled)
        .filter((emp) => employeeCanDoService(emp, booking, services))
        .filter((emp) => employeeAvailableForBooking(emp, booking))
        .filter((emp) => !employeeHasBookingConflict(emp, booking, sourceBookings));
    },
    [employees, services, allBookings, toConfirmList, pendingList]
  );

  const handleApproveReject = async (booking, accept, assignedEmployee = null) => {
    if (!isAdmin && !isWorkerPendingScope) return alert("No tienes permisos.");
    setStatusMessage(null);

    if (!isWorkerPendingScope && accept && isUnassignedBooking(booking) && !assignedEmployee && !bookingDoesNotRequireWorker(booking)) {
      setAssignBooking(booking);
      return;
    }

    if (!isWorkerPendingScope && accept && bookingDoesNotRequireWorker(booking) && !assignedEmployee && (employees || []).filter((emp) => !emp?.disabled).length > 0) {
      setAssignBooking(booking);
      return;
    }

    try {
      const allowed = isWorkerPendingScope ? true : await isCurrentUserOwnerOrAdmin();
      if (!allowed) {
        alert("No tienes permiso para modificar esta reserva. Verifica ownerUid o admin docs en Firestore.");
        return;
      }
      const newStatus = accept ? "confirmed" : "rejected";
      const locationInfo = getBookingLocationInfo(booking);
      const updatePayload = {
        status: newStatus,
        visitMode: booking.visitMode || booking.visitTypeLocation || (locationInfo.isDelivery ? "delivery" : "onsite"),
        visitTypeLocation: booking.visitTypeLocation || booking.visitMode || (locationInfo.isDelivery ? "delivery" : "onsite"),
        customerLocation: booking.customerLocation || null,
        serviceAreaMatched: booking.serviceAreaMatched || booking.matchedServiceArea || null,
        customerExactAddress: locationInfo.exact || null,
        customerAddressDetails: locationInfo.exact || null,
        deliveryFee: locationInfo.fee || 0,
        locationFee: locationInfo.fee || 0,
        customerLocationLabel: booking.customerLocationLabel || booking.customerLocation?.label || locationInfo.zone || null,
        serviceAreaLabel: booking.serviceAreaLabel || booking.serviceAreaMatched?.label || locationInfo.zone || null,
        deliverySummaryLabel: [locationInfo.modeLabel, locationInfo.zone].filter(Boolean).join(" · "),
        priceBreakdown: booking.priceBreakdown || {
          service: booking.servicePrice ?? booking.basePrice ?? booking.durationPrice ?? null,
          extras: booking.charactersPrice ?? booking.extrasPrice ?? null,
          deliveryFee: locationInfo.fee || 0,
          locationFee: locationInfo.fee || 0,
          total: booking.totalPrice ?? booking.total ?? null,
        },
        acceptedAt: accept ? (isIosCapacitor() ? new Date().toISOString() : serverTimestamp()) : null,
        updatedAt: isIosCapacitor() ? new Date().toISOString() : serverTimestamp(),
      };

      if (accept && assignedEmployee) {
        const assignedList = Array.isArray(assignedEmployee) ? assignedEmployee : [assignedEmployee];
        const cleanedAssigned = assignedList
          .filter(Boolean)
          .map((emp) => ({
            id: String(emp.id || emp.employeeId || ""),
            name: emp.name || emp.displayName || emp.email || "Trabajador",
            email: emp.email || emp.employeeEmail || emp.workerEmail || "",
          }))
          .filter((emp) => emp.id);

        if (cleanedAssigned.length > 1 || bookingDoesNotRequireWorker(booking)) {
          updatePayload.assignedEmployees = cleanedAssigned;
          updatePayload.assignedEmployeeIds = cleanedAssigned.map((emp) => emp.id);
          updatePayload.employeeId = null;
          updatePayload.resourceId = null;
          updatePayload.employeeName = cleanedAssigned.map((emp) => emp.name).join(", ");
          updatePayload.employeeEmail = cleanedAssigned.map((emp) => emp.email).filter(Boolean).join(", ");
          updatePayload.assignmentStatus = cleanedAssigned.length ? "team_assigned" : "not_required";
          updatePayload.requestedWorkerMode = "team";
          updatePayload.employeeNotRequired = true;
        } else {
          const emp = cleanedAssigned[0];
          updatePayload.employeeId = emp.id;
          updatePayload.resourceId = emp.id;
          updatePayload.employeeName = emp.name || "";
          updatePayload.employeeEmail = emp.email || "";
          updatePayload.assignmentStatus = "assigned";
          updatePayload.requestedWorkerMode = "specific";
        }

        updatePayload.assignedAt = isIosCapacitor() ? new Date().toISOString() : serverTimestamp();
        updatePayload.assignedBy = adminUid || null;
      } else if (accept && bookingDoesNotRequireWorker(booking)) {
        updatePayload.employeeId = null;
        updatePayload.workerId = null;
        updatePayload.resourceId = null;
        updatePayload.employeeName = "";
        updatePayload.employeeEmail = "";
        updatePayload.assignmentStatus = "not_required";
        updatePayload.requestedWorkerMode = "none";
        updatePayload.employeeNotRequired = true;
      }
      if (isWorkerPendingScope) {
        if (!workerPendingEmployeeId) {
          alert("No pude identificar tu perfil de trabajador. Cierra y vuelve a abrir tu agenda.");
          return;
        }
        const action = accept ? "accept_action" : "reject_action";
        const functionsInstance = getFunctions();
        const callable = httpsCallable(functionsInstance, "updateWorkerBookingStatus");
        const workerPayload = {
          ...updatePayload,
          acceptedAt: accept ? new Date().toISOString() : null,
          updatedAt: new Date().toISOString(),
          ...(accept ? {
            employeeId: workerPendingEmployeeId,
            workerId: workerPendingEmployeeId,
            resourceId: workerPendingEmployeeId,
            assignedEmployeeId: workerPendingEmployeeId,
            assignedEmployeeIds: [workerPendingEmployeeId],
            employeeName: workerPendingEmployeeName,
            workerName: workerPendingEmployeeName,
            resourceName: workerPendingEmployeeName,
            employeeEmail: workerPendingEmployeeEmail || null,
            workerEmail: workerPendingEmployeeEmail || null,
            assignmentStatus: "assigned",
            requestedWorkerMode: "specific",
            claimUnassigned: true,
            assignToWorker: true,
          } : {}),
        };
        try {
          window.__LOOP_WORKER_PENDING_ACCEPT_DEBUG__ = {
            stage: "calling_updateWorkerBookingStatus_v15",
            businessId,
            bookingId: booking?.id || booking?.bookingId || null,
            employeeId: workerPendingEmployeeId,
            action,
            at: new Date().toISOString(),
          };
        } catch (_) {}
        const res = await callable({
          businessId,
          bookingId: booking.id || booking.bookingId,
          employeeId: workerPendingEmployeeId,
          status: newStatus,
          action,
          payload: workerPayload,
        });
        try {
          window.__LOOP_WORKER_PENDING_ACCEPT_DEBUG__ = {
            ...(window.__LOOP_WORKER_PENDING_ACCEPT_DEBUG__ || {}),
            stage: "resolved_updateWorkerBookingStatus_v15",
            result: res?.data || null,
            at: new Date().toISOString(),
          };
        } catch (_) {}
        setPendingList((prev) => prev.filter((b) => String(b.id || b.bookingId) !== String(booking.id || booking.bookingId)));
        setStatusMessage({ type: "success", text: `Reserva ${accept ? "aceptada" : "rechazada"}.` });
        if (typeof onRefresh === "function") onRefresh();
        return;
      }

      if (isIosCapacitor()) {
        await fsClient.updateDocByPath(`businesses/${businessId}/bookings/${booking.id}`, updatePayload, { db: firestore });
      } else {
        const bookingRef = doc(firestore, `businesses/${businessId}/bookings`, booking.id);
        await updateDoc(bookingRef, updatePayload);
      }
      try {
        await addDoc(collection(firestore, "notifications"), {
          userId: booking.userId,
          bookingId: booking.id,
          message: accept ? `Tu reserva de "${booking.serviceName || ""}" ha sido aceptada.` : `Tu reserva de "${booking.serviceName || ""}" ha sido rechazada.`,
          createdAt: serverTimestamp(),
        });
      } catch (notifErr) {
        console.error("PendingsPanel: notification failed", notifErr);
      }
      setPendingList((prev) => prev.filter((b) => b.id !== booking.id));
      setStatusMessage({ type: "success", text: `Reserva ${accept ? "aceptada" : "rechazada"}.` });
      if (typeof onRefresh === "function") onRefresh();
    } catch (err) {
      console.error("PendingsPanel: handleApproveReject error", err);
      if (err && (err.code === "permission-denied" || (err.message && err.message.toLowerCase().includes("permission")))) {
        alert("Error actualizando reserva: permisos insuficientes. Comprueba ownerUid o admin docs en Firestore.");
      } else {
        alert("Error actualizando reserva. Revisa la consola para más detalles.");
      }
    }
  };

  const internalHandleMarkAttendance = async (booking, attended) => {
    if (!isAdmin) return alert("No tienes permisos.");
    try {
      const allowed = await isCurrentUserOwnerOrAdmin();
      if (!allowed) {
        alert("No tienes permiso para marcar asistencia. Verifica ownerUid o admin docs en Firestore.");
        return;
      }
      const newStatus = attended ? "attended" : "no-show";
      const payload = {
        status: newStatus,
        needsConfirmation: false,
        markedAt: isIosCapacitor() ? new Date().toISOString() : serverTimestamp(),
        markedBy: adminUid,
        updatedAt: isIosCapacitor() ? new Date().toISOString() : serverTimestamp(),
      };
      if (isIosCapacitor()) {
        await fsClient.updateDocByPath(`businesses/${businessId}/bookings/${booking.id}`, payload, { db: firestore });
      } else {
        const bookingRef = doc(firestore, `businesses/${businessId}/bookings`, booking.id);
        await updateDoc(bookingRef, payload);
      }
      try {
        await addDoc(collection(firestore, "notifications"), {
          userId: booking.userId,
          bookingId: booking.id,
          message: attended ? `El negocio confirmó que asististe a la reserva de "${booking.serviceName || ""}".` : `El negocio reportó que no asististe a la reserva de "${booking.serviceName || ""}".`,
          createdAt: serverTimestamp(),
        });
      } catch (notifErr) {
        console.error("PendingsPanel: notification failed", notifErr);
      }
      setToConfirmList((prev) => prev.filter((b) => b.id !== booking.id));
      setStatusMessage({ type: "success", text: `Reserva marcada como ${newStatus}.` });

      // best-effort recompute counts
      if (booking.userId) {
        try {
          const qg = query(collectionGroup(firestore, "bookings"), where("userId", "==", booking.userId));
          const snap = await getDocs(qg);
          let total = 0,
            attendedCount = 0;
          snap.forEach((d) => {
            const data = d.data() || {};
            const status = (data.status || "").toString().toLowerCase();
            if (status === "cancelled" || status === "rejected") return;
            total += 1;
            if (status === "attended") attendedCount += 1;
          });
          const userRef = doc(firestore, "users", booking.userId);
          try {
            await updateDoc(userRef, {
              attendedCount,
              totalCount: total,
              attendancePercent: total > 0 ? Math.round((attendedCount / total) * 100) : 0,
              attendanceUpdatedAt: serverTimestamp(),
            });
          } catch (writeErr) {
            console.warn("PendingsPanel: write to user doc failed (may be rules)", writeErr);
          }
          await loadUserStats([booking.userId]);
          ensureUserListeners([booking.userId]);
        } catch (err) {
          console.error("PendingsPanel: recompute user counts failed", err);
        }
      }
    } catch (err) {
      console.error("PendingsPanel: internalHandleMarkAttendance error", err);
      alert("Error marcando asistencia. Revisa la consola.");
    }
  };

  const handleMarkAttendance = async (booking, attended) => {
    if (typeof onMarkAttendanceProp === "function") {
      try {
        await onMarkAttendanceProp(booking.id, attended ? "attended" : "no-show");
        setToConfirmList((prev) => prev.filter((b) => b.id !== booking.id));
        setStatusMessage({ type: "success", text: `Reserva marcada como ${attended ? "attended" : "no-show"} (delegado).` });
        if (booking.userId) {
          await loadUserStats([booking.userId]);
          ensureUserListeners([booking.userId]);
        }
      } catch (err) {
        console.error("PendingsPanel: onMarkAttendanceProp failed", err);
        alert("Error delegando marcado de asistencia. Revisa la consola.");
      }
    } else {
      await internalHandleMarkAttendance(booking, attended);
    }
  };

  /* ----------------------
     Filtering/searching helpers
     ---------------------- */
  const normalize = (s) => (s || "").toString().toLowerCase();

  const filteredPending = pendingList.filter((b) => {
    const isFocused = focusedBookingId && String(b.id || b.bookingId || "") === String(focusedBookingId);
    if (isFocused) return true;
    const text = `${b.customerName || ""} ${b.customerEmail || ""} ${b.serviceName || ""}`.toLowerCase();
    if (q && !text.includes(normalize(q))) return false;
    if (filterService && normalize(b.serviceName || "") !== normalize(filterService)) return false;
    return true;
  });

  const servicesSet = Array.from(new Set([...(pendingList || []).map((b) => b.serviceName || "")])).filter(Boolean);

  const activeList = filteredPending;
  const totalPending = pendingList.length;
  const focusedPendingVisible = Boolean(focusedBookingId && pendingList.some((b) => String(b.id || b.bookingId || "") === String(focusedBookingId)));


  useEffect(() => {
    try {
      if (typeof window === "undefined") return;
      window.__LOOP_PENDING_PANEL_HEALTH__ = {

        approvalMode: effectiveApprovalMode,
        approvalModeSource: approvalModeDraft ? "pending-local" : "business-calendar-settings",
        approvalModeSaving,
        approvalModeStatus,
        businessId,
        approvalOnly: true,
        pendingCount: totalPending,
        visibleCount: activeList.length,
        focusedBookingId,
        focusedPendingVisible,
        notificationRoute: window.__LOOP_PUSH_LAST_ROUTE__ || null,
        updatedAt: new Date().toISOString(),
      };
    } catch (_) {}
  }, [businessId, totalPending, activeList.length, focusedBookingId, focusedPendingVisible]);

  const pendingPotentialTotal = pendingList.reduce((sum, booking) => sum + getBookingTotalValue(booking), 0);
  const unassignedPendingCount = pendingList.filter((booking) => isUnassignedBooking(booking) && !bookingDoesNotRequireWorker(booking)).length;
  const todayPendingCount = pendingList.filter((booking) => {
    const d = bookingStartDate(booking);
    return d ? sameCalendarDay(d, new Date()) : false;
  }).length;

  const pendingGroupLabelForBooking = (booking) => {
    const d = bookingStartDate(booking);
    if (!d) return { key: "sin_fecha", label: "Sin fecha" };
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const diffDays = Math.round((target - today) / 86400000);
    if (diffDays === 0) return { key: "hoy", label: "Hoy" };
    if (diffDays === 1) return { key: "manana", label: "Mañana" };
    if (diffDays > 1 && diffDays <= 7) return { key: "esta_semana", label: "Esta semana" };
    if (diffDays < 0) return { key: "atrasadas", label: "Atrasadas" };
    return { key: "mas_adelante", label: "Más adelante" };
  };

  const groupPendingBookings = (rows = []) => {
    const order = ["atrasadas", "hoy", "manana", "esta_semana", "mas_adelante", "sin_fecha"];
    const map = new Map();
    (rows || []).forEach((booking) => {
      const group = pendingGroupLabelForBooking(booking);
      if (!map.has(group.key)) map.set(group.key, { ...group, items: [] });
      map.get(group.key).items.push(booking);
    });
    return Array.from(map.values()).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
  };

  const pendingGroups = groupPendingBookings(filteredPending);

  function EmptyState() {
    const filtered = Boolean(q.trim() || filterService);
    return <section className="pending-clean-empty" aria-live="polite">
      <span className="pending-clean-empty-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><rect x="4" y="5" width="16" height="16" rx="3"/><path d="M8 3v4m8-4v4M4 11h16m-12 5 3 3 5-5"/></svg></span>
      <h3>{filtered ? "Sin coincidencias" : "Todo al día"}</h3>
      <p>{filtered ? "Prueba otro nombre o servicio para encontrar la solicitud." : "No tienes solicitudes por aprobar. Las nuevas reservas pendientes aparecerán aquí."}</p>
      {filtered && <button type="button" onClick={()=>{setQ("");setFilterService("");}}>Limpiar filtros</button>}
    </section>;
  }

  const assignWorkerOptions = assignBooking ? getAvailableWorkersForBooking(assignBooking) : [];

  const openApprovalConfirm = (booking, accept) => {
    confirmRef.current = {
      action: () => handleApproveReject(booking, accept),
      title: accept ? "Aceptar reserva" : "Rechazar reserva",
      desc: accept
        ? `¿Confirmas aceptar la reserva de ${booking.customerName || "cliente"}?`
        : `¿Confirmas rechazar la reserva de ${booking.customerName || "cliente"}?`,
      destructive: !accept,
    };
    setConfirmOpen(true);
  };

  // Attendance/no-show actions were intentionally removed from Pending Panel.
  // Those operational states now live in Agenda detail.

  const renderRevampBookingCard = (booking, mode = "approval") => {
    const loc = getBookingLocationInfo(booking);
    const isUnassigned = isUnassignedBooking(booking) && !bookingDoesNotRequireWorker(booking);
    const workerLabel = workerLabelForBooking(booking, employees);
    const total = getBookingTotalValue(booking);
    const servicePreview = getBookingServicePreview(booking);
    const startDate = bookingStartDate(booking);
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const isOverdue = Boolean(startDate && startDate < todayStart);
    const isFocusedFromNotification = Boolean(focusedBookingId && String(booking.id || booking.bookingId || "") === String(focusedBookingId));
    const workerBadge = bookingDoesNotRequireWorker(booking) ? "Sin equipo requerido" : workerLabel;

    return (
      <article
        key={booking.id}
        className={`pending-revamp-card pending-inbox-card ${isUnassigned ? "is-unassigned" : ""} ${isOverdue ? "is-overdue" : ""} ${loc.isDelivery ? "is-delivery" : ""} ${isFocusedFromNotification ? "is-focused-from-notification" : ""}`}
      >
        <div className="pending-inbox-leading">
          <div className="pending-inbox-avatar">{(booking.customerName || "?").trim().slice(0, 1).toUpperCase() || "?"}</div>
          <div className="pending-inbox-copy">
            <span className="pending-inbox-kicker">{isOverdue ? "Atrasada" : isUnassigned ? "Requiere asignación" : "Nueva solicitud"}</span>
            <strong>{booking.customerName || "Cliente"}</strong>
            <p>{servicePreview} · {friendlyDateTime(booking)}</p>
            <div className="pending-inbox-meta">
              <span className={`pending-inbox-pill ${loc.isDelivery ? "is-delivery" : ""}`}>
                {loc.isDelivery ? "A domicilio" : "En local"}{loc.zone ? ` · ${loc.zone}` : ""}
              </span>
              <span className={`pending-inbox-pill ${isUnassigned ? "is-unassigned" : ""}`}>
                {workerBadge}
              </span>
              <PendingMembershipPill booking={booking} />
            </div>
          </div>
        </div>

        <div className="pending-inbox-total">
          <span>Total</span>
          <strong>{money(total)}</strong>
        </div>

        <div className="pending-revamp-actions pending-inbox-actions">
          <button type="button" className="pending-inbox-detail-btn" onClick={() => setDetailBooking(booking)}>
            Ver detalle
          </button>
          <button type="button" className="pending-inbox-reject-btn" onClick={() => openApprovalConfirm(booking, false)}>
            Rechazar
          </button>
          <button type="button" className="pending-inbox-accept-btn" onClick={() => openApprovalConfirm(booking, true)}>
            {isUnassigned ? "Asignar" : "Aceptar"}
          </button>
        </div>
      </article>
    );
  };

  const renderGroupedBookings = (groups, mode = "approval") => {
    if (!groups.length) return <EmptyState type="pending" />;
    return (
      <div>
        {groups.map((group) => (
          <section key={group.key} className="pendings-date-group">
            <div className="pendings-date-title">
              <span>{group.label}</span>
              <em>{group.items.length} reserva{group.items.length === 1 ? "" : "s"}</em>
            </div>
            <div className="pendings-compact-list">
              {group.items.map((booking) => renderRevampBookingCard(booking, mode))}
            </div>
          </section>
        ))}
      </div>
    );
  };

  /* ----------------------
     Render
     ---------------------- */
  return (
    <div
      className="min-h-screen px-3 py-4 sm:px-6 sm:py-6"
      style={{
        background:
          "radial-gradient(circle at top left, rgba(38,150,144,0.12), transparent 30%), linear-gradient(180deg, #f8fafc 0%, #ffffff 42%, #f8fafc 100%)",
        paddingBottom: isNativeRuntime ? "calc(env(safe-area-inset-bottom, 0px) + 96px)" : undefined,
      }}
    >
      <style>{PENDINGS_MOBILE_FIX_CSS}</style>
      <div className="mx-auto max-w-[1500px] pendings-revamp-shell pending-clean">
        <header className="pending-clean-header">
          <div className="pending-clean-title"><button type="button" onClick={onBack} aria-label="Volver a la agenda">←</button><div><span>RESERVAS</span><h1>Solicitudes pendientes</h1><p>Revisa cada solicitud y confirma los próximos turnos.</p></div></div>
          <button type="button" className="pending-clean-mode" onClick={openApprovalModeModal} disabled={approvalModeSaving}><span>Aprobación <strong>{isAutoApprovalMode ? "automática" : "manual"}</strong></span><span>{approvalModeSaving ? "Guardando…" : "Cambiar"}</span></button>
        </header>
        {approvalModeStatus && <p role="status" className="pending-clean-feedback">{approvalModeStatus}</p>}
        <div className="pending-clean-summary" aria-label="Resumen de solicitudes">
          <span><strong>{totalPending}</strong> por aprobar</span><span><strong>{unassignedPendingCount}</strong> sin asignar</span><span><strong>{todayPendingCount}</strong> para hoy</span><span><strong>{money(pendingPotentialTotal)}</strong> valor de solicitudes</span>
        </div>

        <section className={`pendings-filter-bar pending-compact-filters ${compactFiltersOpen ? "is-expanded" : ""} mb-3 rounded-[26px] border border-slate-200 bg-white/88 p-3 shadow-md`}>
          <div className="grid gap-2 lg:grid-cols-[1fr_230px_auto] lg:items-center">
            <div className="relative">
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                aria-label="Buscar solicitudes"
                placeholder="Buscar cliente, correo o servicio"
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 pr-11 text-sm font-bold text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
              />
              <svg className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" viewBox="0 0 24 24" fill="none" aria-hidden>
                <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.5" />
                <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>

            <button type="button" className="pending-filter-toggle" aria-expanded={compactFiltersOpen} onClick={() => setCompactFiltersOpen(open => !open)}>Filtros{filterService ? " · 1" : ""}</button>
            <select
              aria-label="Filtrar por servicio"
              value={filterService}
              onChange={(e) => setFilterService(e.target.value)}
              className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700 outline-none focus:border-emerald-400 focus:ring-4 focus:ring-emerald-100"
            >
              <option value="">Todos los servicios</option>
              {servicesSet.map((serviceName) => (
                <option key={serviceName} value={serviceName}>
                  {serviceName}
                </option>
              ))}
            </select>


            <button
              type="button"
              onClick={() => { setQ(""); setFilterService(""); }}
              className="min-h-[46px] rounded-2xl border border-slate-200 bg-white px-4 text-sm font-black text-slate-700 transition hover:bg-slate-50 active:scale-[0.98]"
            >
              Limpiar
            </button>
          </div>
        </section>

        {focusedBookingId ? (
          <div className={`pending-notification-bridge mb-4 ${focusedPendingVisible ? "" : "is-missing"}`}>
            <span>
              <strong>{focusedPendingVisible ? "Abierta desde campanita" : "Campanita recibida"}</strong>
              {focusedPendingVisible
                ? " · la reserva enlazada está visible en esta lista."
                : " · esa reserva ya no está pendiente o pertenece a otro negocio."}
            </span>
            <span>{focusedBookingId}</span>
          </div>
        ) : null}

        {/* content */}
        <div className="pb-3">
          {loading ? (
            <div className="grid gap-3">
              {[1, 2, 3].map((item) => (
                <div key={item} className="pending-revamp-loading-card" />
              ))}
            </div>
          ) : (
            renderGroupedBookings(pendingGroups, "approval")
          )}
        </div>

      {/* status message */}
      {statusMessage && (
        <div className={`mt-5 rounded-3xl border px-5 py-4 text-sm font-black ${statusMessage.type === "success" ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-red-200 bg-red-50 text-red-700"}`}>
          {statusMessage.text}
        </div>
      )}

      <ApprovalModeSettingsModal
        open={approvalModeModalOpen}
        value={approvalModeModalDraft || effectiveApprovalMode}
        saving={approvalModeSaving}
        status={approvalModeModalError}
        onChange={(nextMode) => {
          setApprovalModeModalDraft(nextMode === "auto" ? "auto" : "manual");
          setApprovalModeModalError("");
        }}
        onClose={() => {
          if (approvalModeSaving) return;
          setApprovalModeModalOpen(false);
          setApprovalModeModalError("");
        }}
        onSave={(nextMode) => saveApprovalModeFromPending(nextMode)}
      />

      {/* confirm modal */}
      <CustomerDetailModal
        booking={detailBooking}
        stats={detailBooking && detailBooking.userId ? userStats[detailBooking.userId] : null}
        employees={employees}
        onClose={() => setDetailBooking(null)}
      />

      <AssignWorkerModal
        open={Boolean(assignBooking)}
        booking={assignBooking}
        workers={assignWorkerOptions}
        loading={assigningWorker}
        onClose={() => setAssignBooking(null)}
        multi={Boolean(assignBooking && bookingDoesNotRequireWorker(assignBooking))}
        onSkip={async () => {
          if (!assignBooking) return;
          setAssigningWorker(true);
          try {
            await handleApproveReject(assignBooking, true, []);
            setAssignBooking(null);
          } finally {
            setAssigningWorker(false);
          }
        }}
        onAssign={async (worker) => {
          if (!assignBooking || !worker) return;
          setAssigningWorker(true);
          try {
            await handleApproveReject(assignBooking, true, worker);
            setAssignBooking(null);
          } finally {
            setAssigningWorker(false);
          }
        }}
      />

      <ConfirmModal
        open={confirmOpen}
        title={confirmRef.current.title || "Confirmar acción"}
        description={confirmRef.current.desc || "¿Estás seguro?"}
        destructive={confirmRef.current.destructive}
        confirmText={confirmRef.current.destructive ? "Sí, confirmar" : "Confirmar"}
        onClose={() => setConfirmOpen(false)}
        onConfirm={async () => {
          try {
            setConfirmOpen(false);
            await (confirmRef.current.action && confirmRef.current.action());
          } catch (e) {
            console.error("PendingsPanel: confirm action failed", e);
          }
        }}
      />

      {/* Native bottom attendance tabs removed in Phase 2.5C. Pending panel is approval-only. */}
      </div>
    </div>
  );
}